/*新建案例以及总的数据*/
/**
 * 表单渲染数组
 * @label 标签头
 * @value 双向绑定的值
 * @placeholder 提示值
 * @name  校验规则插槽名，key名，form表单获取名
 * type  类型（0：input，1：select，3：不显示）
 * @warning 是否显示警告
 * @warningMsg 警告信息
 * @focus 获得焦点时的动作
 * @blur 失去焦点或者value值改变时的回调函数
 * @options 下拉框时的下拉菜单的值
 *@测试提交
 */
let data1 = {
  total:[
    {
      label: "*事故编号", value: '', placeholder: "事故编号", name: "caseNumber", type: 0, warning: 0, warningMsg: "1", readonly: false,
      blur: ((index) => {
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    /*委托编号*/
    {
      label: "*委托编号", value: '', placeholder: "委托编号", name: "commissionNumber", type: 0, warning: 0, warningMsg: "1", readonly: false,
      blur: ((index) => {

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {
      label: "*事故具体类型", value: '', placeholder: "事故具体类型", name: "accidentType", type: 0, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {
      label: "*参与方总数", value: '', placeholder: "", name: "participantsNum", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '1'
        },
        {
          value: '2',
          label: '2'
        }
      ]
    },
    {
      label: "*事故形态", value: '',placeholder: "", name: "accidentForm", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '人与汽车相撞'
        },
        {
          value: '2',
          label: '非机动车与汽车相撞'
        },
        {
          value: '3',
          label: '机动二/三轮车与汽车相撞'
        },
        {
          value: '4',
          label: '汽车单车事故'
        },
        {
          value: '5',
          label: '汽车撞静止车辆'
        },
        {
          value: '6',
          label: '汽车与汽车正面相撞'
        },
        {
          value: '7',
          label: '汽车与汽车侧面碰撞'
        },
        {
          value: '8',
          label: '汽车与汽车尾随相撞'
        },
        {
          value: '9',
          label: '汽车与汽车对向刮撞'
        },
        {
          value: '10',
          label: '汽车与汽车同向刮撞'
        },
        {
          value: '11',
          label: '特殊事故形态'
        }
      ]
    },
    {
      label: "*障碍物类型", value: '', placeholder: "", name: "obstacleType", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '中央隔离带'
        },
        {
          value: '3',
          label: '路边树木/路灯杆'
        },
        {
          value: '4',
          label: '路上放置的牌子'
        },
        {
          value: '5',
          label: '路上的施工围栏'
        },
        {
          value: '6',
          label: '路上固定建筑物'
        },
        {
          value: '7',
          label: '路上临时建筑物'
        },
        {
          value: '8',
          label: '动态障碍物'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {
      label: "*天网及其他视频", value: '', placeholder: "",name: "otherVideo", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '天网监控视频'
        },
        {
          value: '2',
          label: '其他监控视频'
        },
        {
          value: '3',
          label: '无监控视频'
        }
      ]
    },
    {
      label: "*事故分类", value: '', placeholder: "", name: "classificationOfAccidents", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '轻微事故'
        },
        {
          value: '2',
          label: '一般事故'
        },
        {
          value: '3',
          label: '重大事故'
        },
        {
          value: '4',
          label: '特大事故'
        }
      ]
    },
    /*场景类别暂无*/
    {
      label: "*参与方类别", value: '', placeholder: "参与方类别",name: "typeOfParticipants", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '车—人'
        },
        {
          value: '2',
          label: '车—车'
        },
        {
          value: '3',
          label: '车—二轮车'
        }
      ]
    },
    {
      label: "*目标与主车行驶方向关系", value: '', placeholder: "",name: "relationshipBetweenTargetAndDirection", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data1.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '左方来车'
        },
        {
          value: '2',
          label: '右方来车'
        },
        {
          value: '3',
          label: '对向来车'
        },
        {
          value: '4',
          label: '同向行驶'
        }
      ]
    },
  ],
  env:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      blur: ((index) => {
        let data = this.a.data1.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data1.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*事故地点",value:'',placeholder:"事故地点",name:"accidentAddress",type:0,warning:0,warningMsg:"",readonly:false,
      blur: ((index) => {
        let data = this.a.data1.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data1.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*路段信息",value:'',placeholder:"",name:"roadInformation",type:1,warning:0,warningMsg:"",readonly:false,
      blur: ((index) => {
        let data = this.a.data1.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data1.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value: '1',
          label: '三枝分叉口'
        },
        {
          value: '2',
          label: '四枝分叉口'
        },
        {
          value: '3',
          label: '多枝分叉口'
        },
        {
          value: '4',
          label: '环形交叉'
        },
        {
          value: '5',
          label: '匝道口'
        },
        {
          value: '6',
          label: '普通路段'
        },
        {
          value: '7',
          label: '高架路段'
        },
        {
          value: '8',
          label: '变窄路段'
        },
        {
          value: '9',
          label: '窄路'
        },
        {
          value: '10',
          label: '桥梁'
        },
        {
          value: '11',
          label: '隧道'
        },
        {
          value: '12',
          label: '路段进出处'
        },
        {
          value: '13',
          label: '路侧险要路段'
        },
        {
          value: '14',
          label: '左转弯路段'
        },
        {
          value: '15',
          label: '右转弯路段'
        },
        {
          value: '16',
          label: '变宽路段'
        }
        ,
        {
          value: '17',
          label: '其他特殊路段'
        }

        /*左转弯路段、右转弯路段、变宽路段*/
      ]
    },
    {label:"*天气",value:'',placeholder:"",name:"weather",type:1,warning:0,warningMsg:"",readonly:false,
      blur: ((index) => {
        let data = this.a.data1.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data1.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '晴'
        },
        {
          value: '2',
          label: '阴'
        },
        {
          value: '3',
          label: '雨'
        },
        {
          value: '4',
          label: '雪'
        },
        {
          value: '5',
          label: '雾'
        },
        {
          value: '6',
          label: '大风'
        },
        {
          value: '7',
          label: '沙尘'
        },
        {
          value: '8',
          label: '冰雹'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"*事故发生时段",value:'',placeholder:"",name:"periodOfAccident",type:1,warning:0,warningMsg:"",readonly:false,
      blur: ((index) => {
        let data = this.a.data1.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data1.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '日间'
        },
        {
          value: '2',
          label: '夜间'
        },
        {
          value: '3',
          label: '晨昏'
        }
      ]
    },
    {label:"照明情况",value:'',placeholder:"",name:"lightingSituation",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '1',
          label: '良好'
        },
        {
          value: '2',
          label: '差，对事故产生一定影响'
        },
        {
          value: '3',
          label: '未知'
        }
      ]
    },
    {label:"日间太阳光线",value:'',placeholder:"",name:"lightCondition",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '1',
          label: '太阳光线较强'
        },
        {
          value: '2',
          label: '太阳光线一般'
        },
        {
          value: '3',
          label: '太阳光线较弱'
        }
      ]
    },
    {label:"雾天的能见度",value:'',placeholder:"",name:"visibilityInFog",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '1',
          label: '小于50米（强浓雾）'
        },
        {
          value: '2',
          label: '小于200米（浓雾）'
        },
        {
          value: '3',
          label: '小于500米（大雾）'
        },
        {
          value: '4',
          label: '小于1000米（雾）'
        },
        {
          value: '5',
          label: '1-10公里（轻雾）'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"降水量",value:'',placeholder:"",name:"precipitation",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '1',
          label: '小雨'
        },
        {
          value: '2',
          label: '中雨'
        },
        {
          value: '3',
          label: '大雨'
        },
        {
          value: '4',
          label: '暴雨'
        },
        {
          value: '5',
          label: '大暴雨'
        },
        {
          value: '6',
          label: '特大暴雨'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"降雪量",value:'',placeholder:"",name:"snowfall",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '1',
          label: '小雪'
        },
        {
          value: '2',
          label: '中雪'
        },
        {
          value: '3',
          label: '大雪'
        },
        {
          value: '4',
          label: '暴雪'
        },
        {
          value: '5',
          label: '大暴雪'
        },
        {
          value: '6',
          label: '特大暴雪'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"摄氏温度（℃）",value:'',placeholder:"",name:"temperature",type:0,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {}
      ]
    },
    {label:"风速",value:'',placeholder:"",name:"windSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {}
      ]
    },
    {label:"风级",value:'',placeholder:"",name:"windLevel",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '0',
          label: '0'
        },
        {
          value: '1',
          label: '1'
        },
        {
          value: '2',
          label: '2'
        },
        {
          value: '3',
          label: '3'
        },
        {
          value: '4',
          label: '4'
        },
        {
          value: '5',
          label: '5'
        },
        {
          value: '6',
          label: '6'
        },
        {
          value: '7',
          label: '7'
        }
        ,
        {
          value: '8',
          label: '8'
        },
        {
          value: '9',
          label: '9'
        },
        {
          value: '10',
          label: '10'
        },
        {
          value: '11',
          label: '11'
        },
        {
          value: '12',
          label: '12'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"风向",value:'',placeholder:"",name:"windDirection",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '1',
          label: '北'
        },
        {
          value: '2',
          label: '东北'
        },
        {
          value: '3',
          label: '东'
        },
        {
          value: '4',
          label: '东南'
        },
        {
          value: '5',
          label: '南'
        },
        {
          value: '6',
          label: '西南'
        },
        {
          value: '7',
          label: '西'
        },
        {
          value: '8',
          label: '西北'
        },
        {
          value: '999',
          label: '未知'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"经度",value:'',placeholder:"",name:"eastLongitude",type:0,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {}
      ]
    },
    {label:"纬度",value:'',placeholder:"",name:"northLatitude",type:0,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {}
      ]
    }
  ],
  road:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'1',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*参与方道路所在名称",value:'',placeholder:"",name:"roadName",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    /*是否为变宽路段*/
    {label:"*是否为变宽路段",value:'',placeholder:"是否为变宽路段",name:"whetherItIsAWidenedSection",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'999-未知'
        },
      ]
    },
    /*是否有为变窄路段*/
    {label:"*是否为变窄路段",value:'',placeholder:"是否有为变窄路段",name:"whetherThereANarrowSection",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'未知'
        },
      ]
    },
    /*是否有隧道*/
    {label:"*是否有隧道",value:'',placeholder:"是否有隧道",name:"whetherThereATunnel",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'未知'
        },
      ]
    },
    /*是否为匝道口*/
    {label:"*是否为匝道口",value:'',placeholder:"是否为匝道口",name:"whetherItARamp",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'未知'
        },
      ]
    },
    {label:"事故地点道路走向",value:'',placeholder:"",name:"directionRoadAtCollisionPoint",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '南北'
        },
        {
          value: '2',
          label: '东西'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"道路行政等级",value:'',placeholder:"",name:"administrativeRankOfRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '公路'
        },
        {
          value: '2',
          label: '城市道路'
        },
        {
          value: '3',
          label: '厂矿道路'
        },
        {
          value: '4',
          label: '林区道路'
        },
        {
          value: '5',
          label: '乡村道路'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"公路等级",value:'',placeholder:"",name:"classOfRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '高速公路'
        },
        {
          value: '2',
          label: '一级公路'
        },
        {
          value: '3',
          label: '二级公路'
        },
        {
          value: '4',
          label: '三级公路'
        },
        {
          value: '5',
          label: '四级公路'
        },
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"城市道路类型",value:'',placeholder:"",name:"typeOfCityRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '快速路'
        },
        {
          value: '2',
          label: '主干路'
        },
        {
          value: '3',
          label: '次干路'
        },
        {
          value: '4',
          label: '支路'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"整体机动车道数（条）",value:'',placeholder:"",name:"totalNumberOfMotorVehicleLanes",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"东侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnEastSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"西侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnWestSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"南侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnSouthSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"北侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnNorthSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"非机动车道（东西）",value:'',placeholder:"",name:"nonMotorVehicleLaneOfEastWest",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '仅东侧'
        },
        {
          value: '3',
          label: '仅西侧'
        },
        {
          value: '4',
          label: '两侧均有'
        }
      ]
    },
    {label:"非机动车道（南北）",value:'',placeholder:"",name:"nonMotorVehicleLaneOfSouthNorth",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '仅南侧'
        },
        {
          value: '3',
          label: '仅北侧'
        },
        {
          value: '4',
          label: '两侧均有'
        }
      ]
    },
    {label:"道路横截面的轮廓",value:'',placeholder:"",name:"outlineOfRoadCrossSection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有横向的倾斜'
        },
        {
          value: '2',
          label: '拱形'
        },
        {
          value: '3',
          label: '向一侧横向倾斜'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"对向机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfOppositeVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有隔离'
        },
        {
          value: '2',
          label: '单虚线'
        },
        {
          value: '3',
          label: '单实线'
        },
        {
          value: '4',
          label: '双实线'
        },
        {
          value: '5',
          label: '中央绿化带'
        },
        {
          value: '6',
          label: '隔离栅栏'
        },
        {
          value: '7',
          label: '单向道'
        },
        {
          value: '8',
          label: '石墩隔离'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"东侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfEastNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfWestNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfSourthNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfNorthNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"道路总宽度(m)",value:'',placeholder:"",name:"overallWidthOfRoad",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"道路的线形",value:'',placeholder:"",name:"theLinearShapeOfTheRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平直'
        },
        {
          value: '2',
          label: '一般弯'
        },
        {
          value: '3',
          label: '一般坡'
        },
        {
          value: '4',
          label: '急弯'
        },
        {
          value: '5',
          label: '陡坡'
        },
        {
          value: '6',
          label: '连续下坡'
        },
        {
          value: '7',
          label: '一般弯坡'
        },
        {
          value: '8',
          label: '急弯陡坡'
        },
        {
          value: '9',
          label: '一般坡急弯'
        },
        {
          value: '10',
          label: '一般弯陡坡'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"曲率半径(m)",value:'',placeholder:"",name:"radiusOfCurve",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"沿道路方向的趋势",value:'',placeholder:"",name:"trendsAlongTheRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平坦的'
        },
        {
          value: '2',
          label: '上升'
        },
        {
          value: '3',
          label: '下降'
        }
      ]
    },
    {label:"该趋势的坡度(%)",value:'',placeholder:"",name:"slopeOfTheTrend",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"最高允许车速(km/h)",value:'',placeholder:"",name:"maximumAllowedSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"路面材料",value:'',placeholder:"",name:"typeOfRoadSurface",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '沥青'
        },
        {
          value: '2',
          label: '水泥'
        },
        {
          value: '3',
          label: '沙石'
        },
        {
          value: '4',
          label: '土路'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"道路表面污染",value:'',placeholder:"",name:"surfaceFouling",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '否'
        },
        {
          value: '2',
          label: '油'
        },
        {
          value: '3',
          label: '燃料'
        },
        {
          value: '4',
          label: '污垢'
        },
        {
          value: '5',
          label: '石头'
        },
        {
          value: '6',
          label: '掉落的货物'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"路表潮湿度",value:'',placeholder:"",name:"roadSurfaceHumidity",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '干'
        },
        {
          value: '2',
          label: '湿'
        },
        {
          value: '3',
          label: '冰冻'
        },
        {
          value: '4',
          label: '积雪'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"路面状况",value:'',placeholder:"",name:"roadCondition",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平坦'
        },
        {
          value: '2',
          label: '有凹槽'
        },
        {
          value: '3',
          label: '排水槽'
        },
        {
          value: '4',
          label: '松动的路表'
        },
        {
          value: '5',
          label: '搓衣板状'
        },
        {
          value: '6',
          label: '坑洼'
        },
        {
          value: '7',
          label: '波浪状'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"交通标志是否被遮挡",value:'',placeholder:"",name:"trafficSignsNotVisible",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无交通标志'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '3',
          label: '是，因为植物'
        },
        {
          value: '4',
          label: '是，因为建筑'
        },
        {
          value: '5',
          label: '是，因为车辆'
        },
        {
          value: '6',
          label: '是，因为天气'
        },
        {
          value: '888',
          label: '是，其他'
        }
      ]
    },
    {label:"路口信号灯",value:'',placeholder:"",name:"intersectionSignalLamp",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有'
        },
        {
          value: '2',
          label: '仅有直行信号灯'
        },
        {
          value: '3',
          label: '有直行和转弯信号灯'
        }
      ]
    },
    {label:"现场交通警告标志",value:'',placeholder:"",name:"trafficWarningSign",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"现场交通禁令标志",value:'',placeholder:"",name:"trafficBanSign",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"路灯是否开启",value:'',placeholder:"",name:"streetLighting",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无路灯'
        },
        {
          value: '2',
          label: '有，点亮'
        },
        {
          value: '3',
          label: '有，关闭'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ],
    },
    {label:"路灯密度",value:'',placeholder:"",name:"densityOfStreetLighting",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '稀少的路灯'
        },
        {
          value: '2',
          label: '成列的路灯'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"是否有轨道",value:'',placeholder:"",name:"railsInRoadSurface",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，沿道路方向'
        },
        {
          value: '3',
          label: '有，横穿道路方向'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"影响视线障碍物",value:'',placeholder:"",name:"viewObstacle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，非长期性(如汽车)'
        },
        {
          value: '3',
          label: '有，长期性(如建筑物)'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"道路状况评估",value:'',placeholder:"",name:"roadConditionRating",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '状况良好'
        },
        {
          value: '2',
          label: '差，对交通有影响'
        },
        {
          value: '3',
          label: '差，对交通无影响'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"是否有建筑设施",value:'',placeholder:"",name:"constructionFacilities",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有'
        },
        {
          value: '2',
          label: '因有建筑工地路面变窄'
        },
        {
          value: '3',
          label: '因有建筑工地而改变道路路线'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"交通限速设施",value:'',placeholder:"",name:"trafficSpeedLimitingFacilities",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有'
        },
        {
          value: '2',
          label: '单一凸起减速带'
        },
        {
          value: '3',
          label: '密集凸起圆点减速带'
        },
        {
          value: '4',
          label: '只有限速标志'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"车辆是否冲到相应路边",value:'',placeholder:"",name:"vehiclesRushedToCorrespondingRoadside",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '否'
        },
        {
          value: '2',
          label: '是'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"东侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnEastSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"东侧车道边缘地面",value:'',placeholder:"",name:"eastSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"东侧车道边缘高度",value:'',placeholder:"",name:"eastSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnWestSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧道路边缘地面",value:'',placeholder:"",name:"westSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧道路边缘高度",value:'',placeholder:"",name:"westSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnSouthSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧道路边缘地面",value:'',placeholder:"",name:"southSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧道路边缘高度",value:'',placeholder:"",name:"southSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
      }),
      blur:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnNorthSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧道路边缘地面",value:'',placeholder:"",name:"northSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧道路边缘高度",value:'',placeholder:"",name:"northSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"车辆是否跌入水沟",value:'',placeholder:"",name:"vehicleFellIntoDitch",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '否'
        },
        {
          value: '2',
          label: '是'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"水沟深(cm)",value:'',placeholder:"",name:"ditchDepth",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"所在车道宽度(m)",value:'',placeholder:"",name:"widthOfLane",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
  ],
  road_copy:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'2',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*参与方道路所在名称",value:'',placeholder:"",name:"roadName",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    /*是否为变宽路段*/
    {label:"*是否为变宽路段",value:'',placeholder:"是否为变宽路段",name:"whetherItIsAWidenedSection",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'999-未知'
        },
      ]
    },
    /*是否有为变窄路段*/
    {label:"*是否为变窄路段",value:'',placeholder:"是否有为变窄路段",name:"whetherThereANarrowSection",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'未知'
        },
      ]
    },
    /*是否有隧道*/
    {label:"*是否有隧道",value:'',placeholder:"是否有隧道",name:"whetherThereATunnel",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'未知'
        },
      ]
    },
    /*是否为匝道口*/
    {label:"*是否为匝道口",value:'',placeholder:"是否为匝道口",name:"whetherItARamp",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'未知'
        },
      ]
    },
    {label:"事故地点道路走向",value:'',placeholder:"",name:"directionRoadAtCollisionPoint",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '南北'
        },
        {
          value: '2',
          label: '东西'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"道路行政等级",value:'',placeholder:"",name:"administrativeRankOfRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '公路'
        },
        {
          value: '2',
          label: '城市道路'
        },
        {
          value: '3',
          label: '厂矿道路'
        },
        {
          value: '4',
          label: '林区道路'
        },
        {
          value: '5',
          label: '乡村道路'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"公路等级",value:'',placeholder:"",name:"classOfRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '高速公路'
        },
        {
          value: '2',
          label: '一级公路'
        },
        {
          value: '3',
          label: '二级公路'
        },
        {
          value: '4',
          label: '三级公路'
        },
        {
          value: '5',
          label: '四级公路'
        },
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"城市道路类型",value:'',placeholder:"",name:"typeOfCityRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '快速路'
        },
        {
          value: '2',
          label: '主干路'
        },
        {
          value: '3',
          label: '次干路'
        },
        {
          value: '4',
          label: '支路'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"整体机动车道数（条）",value:'',placeholder:"",name:"totalNumberOfMotorVehicleLanes",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"东侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnEastSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"西侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnWestSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"南侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnSouthSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"北侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnNorthSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"非机动车道（东西）",value:'',placeholder:"",name:"nonMotorVehicleLaneOfEastWest",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '仅东侧'
        },
        {
          value: '3',
          label: '仅西侧'
        },
        {
          value: '4',
          label: '两侧均有'
        }
      ]
    },
    {label:"非机动车道（南北）",value:'',placeholder:"",name:"nonMotorVehicleLaneOfSouthNorth",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '仅南侧'
        },
        {
          value: '3',
          label: '仅北侧'
        },
        {
          value: '4',
          label: '两侧均有'
        }
      ]
    },
    {label:"道路横截面的轮廓",value:'',placeholder:"",name:"outlineOfRoadCrossSection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有横向的倾斜'
        },
        {
          value: '2',
          label: '拱形'
        },
        {
          value: '3',
          label: '向一侧横向倾斜'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"对向机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfOppositeVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有隔离'
        },
        {
          value: '2',
          label: '单虚线'
        },
        {
          value: '3',
          label: '单实线'
        },
        {
          value: '4',
          label: '双实线'
        },
        {
          value: '5',
          label: '中央绿化带'
        },
        {
          value: '6',
          label: '隔离栅栏'
        },
        {
          value: '7',
          label: '单向道'
        },
        {
          value: '8',
          label: '石墩隔离'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"东侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfEastNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfWestNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfSourthNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfNorthNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"道路总宽度(m)",value:'',placeholder:"",name:"overallWidthOfRoad",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"道路的线形",value:'',placeholder:"",name:"theLinearShapeOfTheRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平直'
        },
        {
          value: '2',
          label: '一般弯'
        },
        {
          value: '3',
          label: '一般坡'
        },
        {
          value: '4',
          label: '急弯'
        },
        {
          value: '5',
          label: '陡坡'
        },
        {
          value: '6',
          label: '连续下坡'
        },
        {
          value: '7',
          label: '一般弯坡'
        },
        {
          value: '8',
          label: '急弯陡坡'
        },
        {
          value: '9',
          label: '一般坡急弯'
        },
        {
          value: '10',
          label: '一般弯陡坡'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"曲率半径(m)",value:'',placeholder:"",name:"radiusOfCurve",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"沿道路方向的趋势",value:'',placeholder:"",name:"trendsAlongTheRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平坦的'
        },
        {
          value: '2',
          label: '上升'
        },
        {
          value: '3',
          label: '下降'
        }
      ]
    },
    {label:"该趋势的坡度(%)",value:'',placeholder:"",name:"slopeOfTheTrend",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"最高允许车速(km/h)",value:'',placeholder:"",name:"maximumAllowedSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"路面材料",value:'',placeholder:"",name:"typeOfRoadSurface",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '沥青'
        },
        {
          value: '2',
          label: '水泥'
        },
        {
          value: '3',
          label: '沙石'
        },
        {
          value: '4',
          label: '土路'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"道路表面污染",value:'',placeholder:"",name:"surfaceFouling",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '否'
        },
        {
          value: '2',
          label: '油'
        },
        {
          value: '3',
          label: '燃料'
        },
        {
          value: '4',
          label: '污垢'
        },
        {
          value: '5',
          label: '石头'
        },
        {
          value: '6',
          label: '掉落的货物'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"路表潮湿度",value:'',placeholder:"",name:"roadSurfaceHumidity",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '干'
        },
        {
          value: '2',
          label: '湿'
        },
        {
          value: '3',
          label: '冰冻'
        },
        {
          value: '4',
          label: '积雪'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"路面状况",value:'',placeholder:"",name:"roadCondition",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平坦'
        },
        {
          value: '2',
          label: '有凹槽'
        },
        {
          value: '3',
          label: '排水槽'
        },
        {
          value: '4',
          label: '松动的路表'
        },
        {
          value: '5',
          label: '搓衣板状'
        },
        {
          value: '6',
          label: '坑洼'
        },
        {
          value: '7',
          label: '波浪状'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"交通标志是否被遮挡",value:'',placeholder:"",name:"trafficSignsNotVisible",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无交通标志'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '3',
          label: '是，因为植物'
        },
        {
          value: '4',
          label: '是，因为建筑'
        },
        {
          value: '5',
          label: '是，因为车辆'
        },
        {
          value: '6',
          label: '是，因为天气'
        },
        {
          value: '888',
          label: '是，其他'
        }
      ]
    },
    {label:"路口信号灯",value:'',placeholder:"",name:"intersectionSignalLamp",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有'
        },
        {
          value: '2',
          label: '仅有直行信号灯'
        },
        {
          value: '3',
          label: '有直行和转弯信号灯'
        }
      ]
    },
    {label:"现场交通警告标志",value:'',placeholder:"",name:"trafficWarningSign",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"现场交通禁令标志",value:'',placeholder:"",name:"trafficBanSign",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"路灯是否开启",value:'',placeholder:"",name:"streetLighting",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无路灯'
        },
        {
          value: '2',
          label: '有，点亮'
        },
        {
          value: '3',
          label: '有，关闭'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ],
    },
    {label:"路灯密度",value:'',placeholder:"",name:"densityOfStreetLighting",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '稀少的路灯'
        },
        {
          value: '2',
          label: '成列的路灯'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"是否有轨道",value:'',placeholder:"",name:"railsInRoadSurface",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，沿道路方向'
        },
        {
          value: '3',
          label: '有，横穿道路方向'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"影响视线障碍物",value:'',placeholder:"",name:"viewObstacle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，非长期性(如汽车)'
        },
        {
          value: '3',
          label: '有，长期性(如建筑物)'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"道路状况评估",value:'',placeholder:"",name:"roadConditionRating",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '状况良好'
        },
        {
          value: '2',
          label: '差，对交通有影响'
        },
        {
          value: '3',
          label: '差，对交通无影响'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"是否有建筑设施",value:'',placeholder:"",name:"constructionFacilities",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有'
        },
        {
          value: '2',
          label: '因有建筑工地路面变窄'
        },
        {
          value: '3',
          label: '因有建筑工地而改变道路路线'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"交通限速设施",value:'',placeholder:"",name:"trafficSpeedLimitingFacilities",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有'
        },
        {
          value: '2',
          label: '单一凸起减速带'
        },
        {
          value: '3',
          label: '密集凸起圆点减速带'
        },
        {
          value: '4',
          label: '只有限速标志'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"车辆是否冲到相应路边",value:'',placeholder:"",name:"vehiclesRushedToCorrespondingRoadside",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '否'
        },
        {
          value: '2',
          label: '是'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"东侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnEastSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"东侧车道边缘地面",value:'',placeholder:"",name:"eastSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"东侧车道边缘高度",value:'',placeholder:"",name:"eastSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnWestSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧道路边缘地面",value:'',placeholder:"",name:"westSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧道路边缘高度",value:'',placeholder:"",name:"westSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnSouthSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧道路边缘地面",value:'',placeholder:"",name:"southSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧道路边缘高度",value:'',placeholder:"",name:"southSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
      }),
      blur:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnNorthSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧道路边缘地面",value:'',placeholder:"",name:"northSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧道路边缘高度",value:'',placeholder:"",name:"northSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"车辆是否跌入水沟",value:'',placeholder:"",name:"vehicleFellIntoDitch",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '否'
        },
        {
          value: '2',
          label: '是'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"水沟深(cm)",value:'',placeholder:"",name:"ditchDepth",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"所在车道宽度(m)",value:'',placeholder:"",name:"widthOfLane",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"照明",value:'',placeholder:"",name:"lighting",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    }
  ],
  yORn:[
    {
      label:"是",
      value:"1"
    },
    {
      label:"否",
      value:"2"
    },
    {
      label:"未知",
      value:"3"
    }
  ],
  nORy:[
    {
      value:'1',
      label:'无'
    },
    {
      value:'2',
      label:'有，关闭'
    },
    {
      value:'3',
      label:'有，开着'
    },
    {
      value:'4',
      label:'有，未知是否使用'
    },
    {
      value:'999',
      label:'未知'
    }
  ],
  gender:[
    {
      label:"男性",
      value:"1"
    },
    {
      label:"女性",
      value:"2"
    },
    {
      label:"孕妇",
      value:"3"
    },
    {
      label:"未知",
      value:"4"
    }
  ],
  person:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'1',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*年龄",value:'',placeholder:"",name:"age",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*性别",value:'',placeholder:"",name:"gender",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value:'1',
          label:'男性'
        },
        {
          value:'2',
          label:'女性'
        },
        {
          value:'3',
          label:'未知'
        }
      ]
    },
    {label:"*高度(身高)(cm)",value:'',placeholder:"",name:"vehHight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*体重(kg)",value:'',placeholder:"",name:"weight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    /*开始反应到碰撞前是否有应急姿态*/
    {label:"*开始反应到碰撞前是否有应急姿态",value:'',placeholder:"开始反应到碰撞前是否有应急姿态",name:"whetherEmergencyPostureBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*行人是否从障碍物后穿出*/
    {label:"*行人是否从障碍物后穿出",value:'',placeholder:"行人是否从障碍物后穿出",name:"whetherPedestriansWearOutFromObstacles",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*行人意识到危险之前是否加速*/
    {label:"*行人意识到危险之前是否加速",value:'',placeholder:"行人意识到危险之前是否加速",name:"whetherPedestriansBeforeTheyAccelerate",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*事故前行人行走方向是否改变*/
    {label:"*事故前行人行走方向是否改变",value:'',placeholder:"事故前行人行走方向是否改变",name:"whetherWalkingDirectionPedestrianChanges",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"行人速度(km/h)",value:'',placeholder:"",name:"pedestrianSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"参与方颜色(衣着颜色)",value:'',placeholder:"",name:"participantColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"黑暗处或夜间衣物可见性",value:'',placeholder:"",name:"visibilityInTheDarkOrAtNight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'明亮的'
        },
        {
          value:'2',
          label:'深色的/不可见'
        },
        {
          value:'3',
          label:'反光的'
        },
        {
          value:'4',
          label:'发光的'
        },
        {
          value:'888',
          label:'其他'
        }
      ]
    },
    {label:"主要过错",value:'',placeholder:"",name:"mainAccidentCause",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'000',
          label:'无过失'
        },
        {
          value:'401',
          label:'违法上道路行驶'
        },
        {
          value:'402',
          label:'违法占道'
        },
        {
          value:'403',
          label:'违法装载超限及危险品运输'
        },
        {
          value:'404',
          label:'违反交通信号'
        },
        {
          value:'405',
          label:'其他影响安全行为'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"事故发生地点(行人被撞地点)",value:'',placeholder:"",name:"accidentLocation",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '人行道'
        },
        {
          value: '2',
          label: '非机动车道'
        },
        {
          value: '3',
          label: '机动车道'
        },
        {
          value: '4',
          label: '高速/高架'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"行人穿越机动车道位置",value:'',placeholder:"",name:"pedestrianCrossingTheMotorwayLocation",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '未穿越'
        },
        {
          value: '2',
          label: '有红绿灯处'
        },
        {
          value: '3',
          label: '斑马线处'
        },
        {
          value: '4',
          label: '行人专用通道'
        },
        {
          value: '5',
          label: '无行人过街保护的机动车道路'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"行人行走方向",value:'',placeholder:"",name:"pedestrianWalkingDirection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '从车辆左侧'
        },
        {
          value: '2',
          label: '从车辆右侧'
        },
        {
          value: '3',
          label: '沿车辆运动方向'
        },
        {
          value: '4',
          label: '静止'
        }
      ]
    },
    {label:"行人运动状态",value:'',placeholder:"",name:"pedestrianMovement",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '静止'
        },
        {
          value: '2',
          label: '缓慢步行'
        },
        {
          value: '3',
          label: '快速步行'
        },
        {
          value: '4',
          label: '跑步'
        },
        {
          value: '5',
          label: '前一次碰撞后非正常运动状态'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"行人被撞部位",value:'',placeholder:"",name:"pedestrianBeingHit",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '前方'
        },
        {
          value: '2',
          label: '后方'
        },
        {
          value: '3',
          label: '左侧'
        },
        {
          value: '4',
          label: '右侧'
        },
        {
          value: '5',
          label: '碰撞前跌倒，躺在地上'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"碰撞前行人相对于车辆的位置",value:'',placeholder:"",name:"positionOfPedestrianRelativeToVehicleBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '前方'
        },
        {
          value: '2',
          label: '后方'
        },
        {
          value: '3',
          label: '左侧'
        },
        {
          value: '4',
          label: '右侧'
        }
      ]
    },
    {label:"穿越机动车道时能否被看到",value:'',placeholder:"",name:"canYouBeSeenWhenCrossingTheMotorway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '可以看见'
        },
        {
          value: '2',
          label: '因停驻的车而看不到'
        },
        {
          value: '3',
          label: '因植物而看不到'
        },
        {
          value: '4',
          label: '因建筑物而看不到'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"是否因为视野盲区造成事故",value:'',placeholder:"",name:"whetherItIsCausedByBlindSpotOfVision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.person[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"是否因为停靠车辆造成行人视野盲区:",value:'',placeholder:"",name:"whetherBlindareaOfPedestrianIsCausedByParkedVehicle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.person[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"是否有其他造成行人视线盲区物体:",value:'',placeholder:"",name:"areThereOtherObjectsThatCausePedestrianBlindSpots",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.person[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    }
  ],
  person_copy:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'2',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*年龄",value:'',placeholder:"",name:"age",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*性别",value:'',placeholder:"",name:"gender",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value:'1',
          label:'男性'
        },
        {
          value:'2',
          label:'女性'
        },
        {
          value:'3',
          label:'未知'
        }
      ]
    },
    {label:"*高度(身高)(cm)",value:'',placeholder:"",name:"vehHight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*体重(kg)",value:'',placeholder:"",name:"weight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    /*开始反应到碰撞前是否有应急姿态*/
    {label:"*开始反应到碰撞前是否有应急姿态",value:'',placeholder:"开始反应到碰撞前是否有应急姿态",name:"whetherEmergencyPostureBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*行人是否从障碍物后穿出*/
    {label:"*行人是否从障碍物后穿出",value:'',placeholder:"行人是否从障碍物后穿出",name:"whetherPedestriansWearOutFromObstacles",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*行人意识到危险之前是否加速*/
    {label:"*行人意识到危险之前是否加速",value:'',placeholder:"行人意识到危险之前是否加速",name:"whetherPedestriansBeforeTheyAccelerate",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*事故前行人行走方向是否改变*/
    {label:"*事故前行人行走方向是否改变",value:'',placeholder:"事故前行人行走方向是否改变",name:"whetherWalkingDirectionPedestrianChanges",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"行人速度(km/h)",value:'',placeholder:"",name:"pedestrianSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"参与方颜色(衣着颜色)",value:'',placeholder:"",name:"participantColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"黑暗处或夜间衣物可见性",value:'',placeholder:"",name:"visibilityInTheDarkOrAtNight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'明亮的'
        },
        {
          value:'2',
          label:'深色的/不可见'
        },
        {
          value:'3',
          label:'反光的'
        },
        {
          value:'4',
          label:'发光的'
        },
        {
          value:'888',
          label:'其他'
        }
      ]
    },
    {label:"主要过错",value:'',placeholder:"",name:"mainAccidentCause",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'000',
          label:'无过失'
        },
        {
          value:'401',
          label:'违法上道路行驶'
        },
        {
          value:'402',
          label:'违法占道'
        },
        {
          value:'403',
          label:'违法装载超限及危险品运输'
        },
        {
          value:'404',
          label:'违反交通信号'
        },
        {
          value:'405',
          label:'其他影响安全行为'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"事故发生地点(行人被撞地点)",value:'',placeholder:"",name:"accidentLocation",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '人行道'
        },
        {
          value: '2',
          label: '非机动车道'
        },
        {
          value: '3',
          label: '机动车道'
        },
        {
          value: '4',
          label: '高速/高架'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"行人穿越机动车道位置",value:'',placeholder:"",name:"pedestrianCrossingTheMotorwayLocation",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '未穿越'
        },
        {
          value: '2',
          label: '有红绿灯处'
        },
        {
          value: '3',
          label: '斑马线处'
        },
        {
          value: '4',
          label: '行人专用通道'
        },
        {
          value: '5',
          label: '无行人过街保护的机动车道路'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"行人行走方向",value:'',placeholder:"",name:"pedestrianWalkingDirection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '从车辆左侧'
        },
        {
          value: '2',
          label: '从车辆右侧'
        },
        {
          value: '3',
          label: '沿车辆运动方向'
        },
        {
          value: '4',
          label: '静止'
        }
      ]
    },
    {label:"行人运动状态",value:'',placeholder:"",name:"pedestrianMovement",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '静止'
        },
        {
          value: '2',
          label: '缓慢步行'
        },
        {
          value: '3',
          label: '快速步行'
        },
        {
          value: '4',
          label: '跑步'
        },
        {
          value: '5',
          label: '前一次碰撞后非正常运动状态'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"行人被撞部位",value:'',placeholder:"",name:"pedestrianBeingHit",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '前方'
        },
        {
          value: '2',
          label: '后方'
        },
        {
          value: '3',
          label: '左侧'
        },
        {
          value: '4',
          label: '右侧'
        },
        {
          value: '5',
          label: '碰撞前跌倒，躺在地上'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"碰撞前行人相对于车辆的位置",value:'',placeholder:"",name:"positionOfPedestrianRelativeToVehicleBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '前方'
        },
        {
          value: '2',
          label: '后方'
        },
        {
          value: '3',
          label: '左侧'
        },
        {
          value: '4',
          label: '右侧'
        }
      ]
    },
    {label:"穿越机动车道时能否被看到",value:'',placeholder:"",name:"canYouBeSeenWhenCrossingTheMotorway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '可以看见'
        },
        {
          value: '2',
          label: '因停驻的车而看不到'
        },
        {
          value: '3',
          label: '因植物而看不到'
        },
        {
          value: '4',
          label: '因建筑物而看不到'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"是否因为视野盲区造成事故",value:'',placeholder:"",name:"whetherItIsCausedByBlindSpotOfVision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.person_copy[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"是否因为停靠车辆造成行人视野盲区:",value:'',placeholder:"",name:"whetherBlindareaOfPedestrianIsCausedByParkedVehicle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.person_copy[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有其他造成行人视线盲区物体:",value:'',placeholder:"",name:"areThereOtherObjectsThatCausePedestrianBlindSpots",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.person_copy[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    }
  ],
  car:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'1',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*车辆类型",value:'',placeholder:"",name:"typeOfParticipant",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'乘用车'
        },
        {
          value:'2',
          label:'客车'
        },
        {
          value:'3',
          label:'货车'
        },
        {
          value:'4',
          label:'半挂牵引车'
        },
        {
          value:'5',
          label:'半挂牵引车及挂车'
        },
        {
          value:'9',
          label:'拖拉机运输机组'
        },
        {
          value:'10',
          label:'轮式专用机械'
        }
      ]
    },
    /*行驶方向*/
    {label:"*行驶方向",value:'',placeholder:"行驶方向",name:"directionOfDriving",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'直行'
        },
        {
          value:'2',
          label:'左转'
        },
        {
          value:'3',
          label:'右转'
        },
        {
          value:'4',
          label:'向左变道'
        },
        {
          value:'5',
          label:'向右变道'
        },
        {
          value:'6',
          label:'倒车'
        },
        {
          value:'7',
          label:'停车'
        },
      ]
    },
    /*事故发生前车辆运动类型*/
    {label:"*事故发生前车辆运动类型",value:'',placeholder:"事故发生前车辆运动类型",name:"vehicleMovementTypeBeforeAccident",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'起步'
        },
        {
          value:'2',
          label:'超车'
        },
        {
          value:'3',
          label:'掉头'
        },
        {
          value:'4',
          label:'倒车'
        },
        {
          value:'5',
          label:'向右变道'
        },
        {
          value:'6',
          label:'向左变道'
        },
        {
          value:'7',
          label:'紧急停车'
        },
        {
          value:'9',
          label:'静止'
        },
        {
          value:'10',
          label:'泊车中'
        },
        {
          value:'11',
          label:'直行加速'
        },
        {
          value:'12',
          label:'直行减速'
        },
        {
          value:'13',
          label:'匀速直行'
        },
        {
          value:'14',
          label:'曲线行驶'
        },
        {
          value:'15',
          label:'左转'
        },
        {
          value:'16',
          label:'右转'
        },
        {
          value:'888',
          label:'其他_________'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*开始反应到碰撞前是否采取转向措施*/
    {label:"*开始反应到碰撞前是否采取转向措施",value:'',placeholder:"开始反应到碰撞前是否采取转向措施",name:"takeSteeringMeasuresBeforeCollision",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'999-未知'
        },
      ]
    },
    {label:"参与方颜色",value:'',placeholder:"",name:"participantColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"轮胎型号",value:'',placeholder:"",name:"tireModel",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '公路'
        },
        {
          value: '2',
          label: '城市道路'
        },
        {
          value: '3',
          label: '厂矿道路'
        },
        {
          value: '4',
          label: '林区道路'
        },
        {
          value: '5',
          label: '乡村道路'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"胎压(bar)",value:'',placeholder:"",name:"tirePressure",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '高速公路'
        },
        {
          value: '2',
          label: '一级公路'
        },
        {
          value: '3',
          label: '二级公路'
        },
        {
          value: '4',
          label: '三级公路'
        },
        {
          value: '5',
          label: '四级公路'
        },
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"定速巡航装置",value:'',placeholder:"",name:"cruiseControl",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，关闭'
        },
        {
          value:'3',
          label:'有，关着'
        },
        {
          value:'4',
          label:'有，未知是否使用'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"自适应巡航ACC",value:'',placeholder:"",name:"adaptiveCruiseAcc",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，关闭'
        },
        {
          value:'3',
          label:'有，关着'
        },
        {
          value:'4',
          label:'有，未知是否使用'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"安全带提醒装置",value:'',placeholder:"",name:"seatBeltReminder",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'只有驾驶员位置有'
        },
        {
          value:'3',
          label:'驾驶员和副驾驶位置都有'
        },
        {
          value:'4',
          label:'第一排和第二排位置都有'
        },
        {
          value:'5',
          label:'第一排和其他排位置都有'
        }
        ,
        {
          value:'888',
          label:'其他'
        }
      ]
    },
    {label:"是否有主动行人保护装置",value:'',placeholder:"",name:"whetherThereIsActivePedestrianProtectionDevice",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'机械控制可抬升发动机罩'
        },
        {
          value:'3',
          label:'爆燃式可抬升发动机罩'
        },
        {
          value:'4',
          label:'行人保护气囊'
        },
        {
          value:'5',
          label:'行人保护保险杠'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"助力转向类型",value:'',placeholder:"",name:"typeOfPowerSteering",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'电动助力转向器'
        },
        {
          value:'3',
          label:'机械液压助力转向器'
        },
        {
          value:'4',
          label:'电控液压助力转向器'
        },
        {
          value:'888',
          label:'其他'
        }
      ]
    },
    {label:"制动执行结构类型",value:'',placeholder:"",name:"typeOfBrakeActuator",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'前后都为盘式'
        },
        {
          value:'2',
          label:'前盘后鼓'
        },
        {
          value:'3',
          label:'前后都为鼓式'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"是否有EBD制动力分配系统",value:'',placeholder:"",name:"ebdBrakingForceDistributionSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"是否有ABS防抱死系统",value:'',placeholder:"",name:"absAntiLockSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"是否有ESP/VSC车身稳定系统",value:'',placeholder:"",name:"espVscBodyStabilizationSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"是否有ASR/TCS/TRC/ATC牵引力控制",value:'',placeholder:"",name:"asrTcsTrcAtcTractionControlSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"是否有EBA/BAS刹车辅助系统",value:'',placeholder:"",name:"ebaBasBrakeAssistantSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"胎压监测装置",value:'',placeholder:"",name:"tirePressureMonitoringDevice",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car[index].options = this.a.data1.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"并线辅助/盲点监测:",value:'',placeholder:"",name:"concurrentAuxiliaryOrBlindSpotMonitoring",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car[index].options = this.a.data1.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"车道偏离预警LDW",value:'',placeholder:"",name:"laneDepartureWarningLdw",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car[index].options = this.a.data1.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"车道保持系统LKA",value:'',placeholder:"",name:"laneKeepingSystemLka",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car[index].options = this.a.data1.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"自动紧急制动(AEB)",value:'',placeholder:"",name:"automaticEmergencyBraking",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car[index].options = this.a.data1.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"预碰撞安全系统Pre-Collision System",value:'',placeholder:"",name:"preCrashSafetySystemPreCollisionSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car[index].options = this.a.data1.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"驾驶员性别",value:'',placeholder:"",name:"driverGender",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car[index].options = this.a.data1.gender;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '男性'
        },
        {
          value: '2',
          label: '女性'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"驾驶员年龄",value:'',placeholder:"",name:"driverAge",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"驾驶员是否分心",value:'',placeholder:"",name:"isTheDriverDistracted",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'2',
          label:'听音乐'
        },
        {
          value:'3',
          label:'导航中'
        },
        {
          value:'4',
          label:'看风景'
        },
        {
          value:'5',
          label:'捡手机'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"驾驶员生理问题",value:'',placeholder:"",name:"driverPhysiology",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'疾病/眩晕'
        },
        {
          value:'2',
          label:'昏昏欲睡'
        },
        {
          value:'3',
          label:'没有生理问题'
        },
        {
          value:'4',
          label:'其他'
        },
        {
          value:'5',
          label:'未知'
        }
      ]
    },
    {label:"行驶方式",value:'',placeholder:"",name:"vehicleTravelled",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单向单车道或单行道'
        },{
          value: '2',
          label: '单向二车道中的右侧车道'
        },{
          value: '3',
          label: '单向二车道中的左侧车道'
        },{
          value: '4',
          label: '单向三车道或三车道以上中的右侧车道'
        },{
          value: '5',
          label: '单向三车道或三车道以上中的中央车道'
        },{
          value: '6',
          label: '单向三车道或三车道以上中的左侧车道　'
        },{
          value: '7',
          label: '反向车道(逆向行驶)'
        },{
          value: '8',
          label: '紧急停车带'
        },{
          value: '9',
          label: '北侧自行车道'
        },{
          value: '10',
          label: '南侧自行车道'
        },{
          value: '11',
          label: '东侧自行车道'
        },{
          value: '12',
          label: '西侧自行车道'
        },{
          value: '13',
          label: '右转车道，直行'
        },{
          value: '14',
          label: '右转车道，右转'
        },{
          value: '15',
          label: '直行车道，直行'
        },{
          value: '16',
          label: '直行车道，右转'
        },{
          value: '17',
          label: '直行车道，左转'
        },{
          value: '18',
          label: '左转车道，直行'
        },{
          value: '19',
          label: '左转车道，左转'
        },{
          value: '20',
          label: '右转/直行车道，右转'
        },{
          value: '21',
          label: '右转/直行车道，直行'
        },{
          value: '22',
          label: '左转/直行车道，左转'
        },{
          value: '23',
          label: '左转/直行车道，直行'
        },{
          value: '24',
          label: '右边非机动车道，直行'
        },{
          value: '25',
          label: '左边非机动车道，直行'
        },{
          value: '26',
          label: '右边非机动车道，左转'
        },{
          value: '27',
          label: '右边非机动车道，右转'
        },{
          value: '28',
          label: '左边非机动车道，右转'
        },{
          value: '29',
          label: '左边非机动车道，左转'
        },{
          value: '30',
          label: '停车'
        },{
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"主要过错",value:'',placeholder:"",name:"mainAccidentCause",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'000',
          label:'无过失'
        },
        {
          value:'101',
          label:'超速行驶'
        },
        {
          value:'102',
          label:'酒后驾驶'
        },
        {
          value:'103',
          label:'逆向行驶'
        },
        {
          value:'104',
          label:'疲劳驾驶'
        },
        {
          value:'105',
          label:'违法变更车道'
        },
        {
          value:'106',
          label:'违法超车'
        },
        {
          value:'107',
          label:'违法倒车'
        },
        {
          value:'108',
          label:'违法掉头'
        },
        {
          value:'109',
          label:'违法会车'
        },
        {
          value:'110',
          label:'违法牵引'
        },
        {
          value:'111',
          label:'违法抢行'
        },
        {
          value:'112',
          label:'违法上道路行驶'
        },
        {
          value:'113',
          label:'违法停车'
        },
        {
          value:'114',
          label:'违法占道行驶'
        },
        {
          value:'115',
          label:'违法装载'
        },
        {
          value:'116',
          label:'违法占道行驶'
        },
        {
          value:'117',
          label:'违反交通信号'
        },
        {
          value:'118',
          label:'未按规定让行'
        },
        {
          value:'119',
          label:'无证驾驶'
        },
        {
          value:'120',
          label:'不按规定使用灯光'
        },
        {
          value:'121',
          label:'其他影响安全行为'
        },
        {
          value:'122',
          label:'未保持安全车距离'
        },
        {
          value:'201',
          label:'制动不当'
        },
        {
          value:'202',
          label:'转向不当'
        },
        {
          value:'203',
          label:'油门控制不当'
        },
        {
          value:'204',
          label:'其他操作不当'
        },
        {
          value:'501',
          label:'未设置道路安全措施'
        },
        {
          value:'502',
          label:'安全设施损坏灭失'
        },
        {
          value:'503',
          label:'道路缺陷'
        },
        {
          value:'504',
          label:'其他道路原因'
        },
        {
          value:'601',
          label:'自然灾害'
        },
        {
          value:'602',
          label:'机械故障'
        },
        {
          value:'603',
          label:'爆胎'
        },
        {
          value:'604',
          label:'其他意外'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"是否有优先权",value:'',placeholder:"",name:"whetherThereAPriority",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'没有'
        },
        {
          value:'2',
          label:'有'
        }
      ]
    },
    {label:"道路方向",value:'',placeholder:"",name:"roadDirection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'0',
          label:'停着不动'
        },
        {
          value:'1',
          label:'直线'
        },
        {
          value:'2',
          label:'左转直线'
        },
        {
          value:'3',
          label:'右转曲线'
        },
        {
          value:'4',
          label:'S型曲线'
        }
      ]
    },
    {label:"行车记录仪数据",value:'',placeholder:"",name:"vehicleRecordData",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，未读取到'
        },
        {
          value:'3',
          label:'有，读取到'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"EDR数据",value:'',placeholder:"",name:"edrData",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，未读取到'
        },
        {
          value:'3',
          label:'有，读取到'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"事故前车辆要避撞的对象",value:'',placeholder:"",name:"objectAvoidCollisionBeforeAccident",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'道路上的物品'
        },
        {
          value:'2',
          label:'极差（极颠簸）的路面'
        },
        {
          value:'3',
          label:'道路上的动物'
        },
        {
          value:'4',
          label:'道路上的车辆'
        },
        {
          value:'5',
          label:'道路上的非机动车'
        },
        {
          value:'6',
          label:'肇事逃逸'
        },
        {
          value:'7',
          label:'驾驶员不在场'
        },
        {
          value:'8',
          label:'其他避撞措施'
        },
        {
          value:'9',
          label:'未知'
        },

        {
          value:'10',
          label:'没有避撞措施'
        },
        {
          value:'11',
          label:'与来车无直接接触'
        }
      ]
    },
    {label:"事故前车辆的避撞行为",value:'',placeholder:"",name:"collisionAvoidanceBehaviorOfFrontVehicle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'驾驶员不在场'
        },
        {
          value:'2',
          label:'没有避撞措施'
        },
        {
          value:'3',
          label:'刹车'
        },
        {
          value:'4',
          label:'释放刹车踏板'
        },
        {
          value:'5',
          label:'转向'
        },
        {
          value:'6',
          label:'刹车并转向'
        },
        {
          value:'7',
          label:'加速'
        },
        {
          value:'8',
          label:'加速并转向'
        },
        {
          value:'9',
          label:'其他'
        },
        {
          value:'10',
          label:'未知'
        }
      ],
    },
    {label:"开始反应到碰撞前是否采取转向措施",value:'',placeholder:"",name:"whetherSteeringBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'是'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"碰撞前制动时间(s)",value:'',placeholder:"",name:"brakingTimeBeforeCollision",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，沿道路方向'
        },
        {
          value: '3',
          label: '有，横穿道路方向'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"碰撞前制动距离(m)",value:'',placeholder:"",name:"brakingDistanceBeforeCollision",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，非长期性(如汽车)'
        },
        {
          value: '3',
          label: '有，长期性(如建筑物)'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"车外是否有视野盲区",value:'',placeholder:"车外",name:"blindAreaOutsideCar",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'隔离带造成'
        },
        {
          value:'3',
          label:'路边树木造成'
        },
        {
          value:'4',
          label:'路上放置的牌子造成'
        },
        {
          value:'5',
          label:'车外人员造成'
        },
        {
          value:'6',
          label:'车外其他车辆造成'
        },
        {
          value:'7',
          label:'路上固定建筑物造成'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"车内是否有视野盲区",value:'',placeholder:"车内",name:"blindAreaInCar",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'车身部分造成'
        },
        {
          value:'3',
          label:'遮阳板造成'
        },
        {
          value:'4',
          label:'后视镜造成'
        },
        {
          value:'5',
          label:'头部支撑造成'
        },
        {
          value:'6',
          label:'乘员造成'
        },
        {
          value:'7',
          label:'载货造成'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"碰撞角度",value:'',placeholder:"",name:"collisionAngle",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"第一接触点离最前部距离X(mm)",value:'',placeholder:"",name:"firstContactPointFromFrontX",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"第一接触点离最前部距离Y(mm)",value:'',placeholder:"",name:"firstContactPointFromFrontY",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"第一接触点离地面距离Z(mm)",value:'',placeholder:"",name:"firstContactPointFromFrontZ",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"车辆初始速度(km/h)",value:'',placeholder:"",name:"normalDrivingSpeedBeforeVehicleCollision",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"碰撞时速度(km/h)",value:'',placeholder:"",name:"collisionVelocity",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"EES(km/h)",value:'',placeholder:"",name:"ees",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"delta V(km/h)",value:'',placeholder:"",name:"deltaV",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    }
  ],
  car_copy:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'2',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*车辆类型",value:'',placeholder:"",name:"typeOfParticipant",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'乘用车'
        },
        {
          value:'2',
          label:'客车'
        },
        {
          value:'3',
          label:'货车'
        },
        {
          value:'4',
          label:'半挂牵引车'
        },
        {
          value:'5',
          label:'半挂牵引车及挂车'
        },
        {
          value:'9',
          label:'拖拉机运输机组'
        },
        {
          value:'10',
          label:'轮式专用机械'
        }
      ]
    },
    /*行驶方向*/
    {label:"*行驶方向",value:'',placeholder:"行驶方向",name:"directionOfDriving",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'直行'
        },
        {
          value:'2',
          label:'左转'
        },
        {
          value:'3',
          label:'右转'
        },
        {
          value:'4',
          label:'向左变道'
        },
        {
          value:'5',
          label:'向右变道'
        },
        {
          value:'6',
          label:'倒车'
        },
        {
          value:'7',
          label:'停车'
        },

      ]
    },
    /*事故发生前车辆运动类型*/
    {label:"*事故发生前车辆运动类型",value:'',placeholder:"事故发生前车辆运动类型",name:"vehicleMovementTypeBeforeAccident",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'起步'
        },
        {
          value:'2',
          label:'超车'
        },
        {
          value:'3',
          label:'掉头'
        },
        {
          value:'4',
          label:'倒车'
        },
        {
          value:'5',
          label:'向右变道'
        },
        {
          value:'6',
          label:'向左变道'
        },
        {
          value:'7',
          label:'紧急停车'
        },
        {
          value:'9',
          label:'静止'
        },
        {
          value:'10',
          label:'泊车中'
        },
        {
          value:'11',
          label:'直行加速'
        },
        {
          value:'12',
          label:'直行减速'
        },
        {
          value:'13',
          label:'匀速直行'
        },
        {
          value:'14',
          label:'曲线行驶'
        },
        {
          value:'15',
          label:'左转'
        },
        {
          value:'16',
          label:'右转'
        },
        {
          value:'888',
          label:'其他_________'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*开始反应到碰撞前是否采取转向措施*/
    {label:"*开始反应到碰撞前是否采取转向措施",value:'',placeholder:"开始反应到碰撞前是否采取转向措施",name:"takeSteeringMeasuresBeforeCollision",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'999-未知'
        },
      ]
    },
    {label:"参与方颜色",value:'',placeholder:"",name:"participantColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"轮胎型号",value:'',placeholder:"",name:"tireModel",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '公路'
        },
        {
          value: '2',
          label: '城市道路'
        },
        {
          value: '3',
          label: '厂矿道路'
        },
        {
          value: '4',
          label: '林区道路'
        },
        {
          value: '5',
          label: '乡村道路'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"胎压(bar)",value:'',placeholder:"",name:"tirePressure",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '高速公路'
        },
        {
          value: '2',
          label: '一级公路'
        },
        {
          value: '3',
          label: '二级公路'
        },
        {
          value: '4',
          label: '三级公路'
        },
        {
          value: '5',
          label: '四级公路'
        },
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"定速巡航装置",value:'',placeholder:"",name:"cruiseControl",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，关闭'
        },
        {
          value:'3',
          label:'有，关着'
        },
        {
          value:'4',
          label:'有，未知是否使用'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"自适应巡航ACC",value:'',placeholder:"",name:"adaptiveCruiseAcc",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，关闭'
        },
        {
          value:'3',
          label:'有，关着'
        },
        {
          value:'4',
          label:'有，未知是否使用'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"安全带提醒装置",value:'',placeholder:"",name:"seatBeltReminder",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'只有驾驶员位置有'
        },
        {
          value:'3',
          label:'驾驶员和副驾驶位置都有'
        },
        {
          value:'4',
          label:'第一排和第二排位置都有'
        },
        {
          value:'5',
          label:'第一排和其他排位置都有'
        }
        ,
        {
          value:'888',
          label:'其他'
        }
      ]
    },
    {label:"是否有主动行人保护装置",value:'',placeholder:"",name:"whetherThereIsActivePedestrianProtectionDevice",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'机械控制可抬升发动机罩'
        },
        {
          value:'3',
          label:'爆燃式可抬升发动机罩'
        },
        {
          value:'4',
          label:'行人保护气囊'
        },
        {
          value:'5',
          label:'行人保护保险杠'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"助力转向类型",value:'',placeholder:"",name:"typeOfPowerSteering",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'电动助力转向器'
        },
        {
          value:'3',
          label:'机械液压助力转向器'
        },
        {
          value:'4',
          label:'电控液压助力转向器'
        },
        {
          value:'888',
          label:'其他'
        }
      ]
    },
    {label:"制动执行结构类型",value:'',placeholder:"",name:"typeOfBrakeActuator",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'前后都为盘式'
        },
        {
          value:'2',
          label:'前盘后鼓'
        },
        {
          value:'3',
          label:'前后都为鼓式'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"是否有EBD制动力分配系统",value:'',placeholder:"",name:"ebdBrakingForceDistributionSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car_copy[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有ABS防抱死系统",value:'',placeholder:"",name:"absAntiLockSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car_copy[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有ESP/VSC车身稳定系统",value:'',placeholder:"",name:"espVscBodyStabilizationSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car_copy[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有ASR/TCS/TRC/ATC牵引力控制",value:'',placeholder:"",name:"asrTcsTrcAtcTractionControlSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car_copy[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有EBA/BAS刹车辅助系统",value:'',placeholder:"",name:"ebaBasBrakeAssistantSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car_copy[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"胎压监测装置",value:'',placeholder:"",name:"tirePressureMonitoringDevice",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car_copy[index].options = this.a.data1.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"并线辅助/盲点监测:",value:'',placeholder:"",name:"concurrentAuxiliaryOrBlindSpotMonitoring",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car_copy[index].options = this.a.data1.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"车道偏离预警LDW",value:'',placeholder:"",name:"laneDepartureWarningLdw",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car_copy[index].options = this.a.data1.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"车道保持系统LKA",value:'',placeholder:"",name:"laneKeepingSystemLka",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car_copy[index].options = this.a.data1.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"自动紧急制动(AEB)",value:'',placeholder:"",name:"automaticEmergencyBraking",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car_copy[index].options = this.a.data1.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"预碰撞安全系统Pre-Collision System",value:'',placeholder:"",name:"preCrashSafetySystemPreCollisionSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car_copy[index].options = this.a.data1.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"驾驶员性别",value:'',placeholder:"",name:"driverGender",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.car_copy[index].options = this.a.data1.gender;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '男性'
        },
        {
          value: '2',
          label: '女性'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"驾驶员年龄",value:'',placeholder:"",name:"driverAge",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"驾驶员是否分心",value:'',placeholder:"",name:"isTheDriverDistracted",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'2',
          label:'听音乐'
        },
        {
          value:'3',
          label:'导航中'
        },
        {
          value:'4',
          label:'看风景'
        },
        {
          value:'5',
          label:'捡手机'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"驾驶员生理问题",value:'',placeholder:"",name:"driverPhysiology",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'疾病/眩晕'
        },
        {
          value:'2',
          label:'昏昏欲睡'
        },
        {
          value:'3',
          label:'没有生理问题'
        },
        {
          value:'4',
          label:'其他'
        },
        {
          value:'5',
          label:'未知'
        }
      ]
    },
    {label:"行驶方式",value:'',placeholder:"",name:"vehicleTravelled",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单向单车道或单行道'
        },{
          value: '2',
          label: '单向二车道中的右侧车道'
        },{
          value: '3',
          label: '单向二车道中的左侧车道'
        },{
          value: '4',
          label: '单向三车道或三车道以上中的右侧车道'
        },{
          value: '5',
          label: '单向三车道或三车道以上中的中央车道'
        },{
          value: '6',
          label: '单向三车道或三车道以上中的左侧车道　'
        },{
          value: '7',
          label: '反向车道(逆向行驶)'
        },{
          value: '8',
          label: '紧急停车带'
        },{
          value: '9',
          label: '北侧自行车道'
        },{
          value: '10',
          label: '南侧自行车道'
        },{
          value: '11',
          label: '东侧自行车道'
        },{
          value: '12',
          label: '西侧自行车道'
        },{
          value: '13',
          label: '右转车道，直行'
        },{
          value: '14',
          label: '右转车道，右转'
        },{
          value: '15',
          label: '直行车道，直行'
        },{
          value: '16',
          label: '直行车道，右转'
        },{
          value: '17',
          label: '直行车道，左转'
        },{
          value: '18',
          label: '左转车道，直行'
        },{
          value: '19',
          label: '左转车道，左转'
        },{
          value: '20',
          label: '右转/直行车道，右转'
        },{
          value: '21',
          label: '右转/直行车道，直行'
        },{
          value: '22',
          label: '左转/直行车道，左转'
        },{
          value: '23',
          label: '左转/直行车道，直行'
        },{
          value: '24',
          label: '右边非机动车道，直行'
        },{
          value: '25',
          label: '左边非机动车道，直行'
        },{
          value: '26',
          label: '右边非机动车道，左转'
        },{
          value: '27',
          label: '右边非机动车道，右转'
        },{
          value: '28',
          label: '左边非机动车道，右转'
        },{
          value: '29',
          label: '左边非机动车道，左转'
        },{
          value: '30',
          label: '停车'
        },{
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"主要过错",value:'',placeholder:"",name:"mainAccidentCause",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'000',
          label:'无过失'
        },
        {
          value:'101',
          label:'超速行驶'
        },
        {
          value:'102',
          label:'酒后驾驶'
        },
        {
          value:'103',
          label:'逆向行驶'
        },
        {
          value:'104',
          label:'疲劳驾驶'
        },
        {
          value:'105',
          label:'违法变更车道'
        },
        {
          value:'106',
          label:'违法超车'
        },
        {
          value:'107',
          label:'违法倒车'
        },
        {
          value:'108',
          label:'违法掉头'
        },
        {
          value:'109',
          label:'违法会车'
        },
        {
          value:'110',
          label:'违法牵引'
        },
        {
          value:'111',
          label:'违法抢行'
        },
        {
          value:'112',
          label:'违法上道路行驶'
        },
        {
          value:'113',
          label:'违法停车'
        },
        {
          value:'114',
          label:'违法占道行驶'
        },
        {
          value:'115',
          label:'违法装载'
        },
        {
          value:'116',
          label:'违法占道行驶'
        },
        {
          value:'117',
          label:'违反交通信号'
        },
        {
          value:'118',
          label:'未按规定让行'
        },
        {
          value:'119',
          label:'无证驾驶'
        },
        {
          value:'120',
          label:'不按规定使用灯光'
        },
        {
          value:'121',
          label:'其他影响安全行为'
        },
        {
          value:'122',
          label:'未保持安全车距离'
        },
        {
          value:'201',
          label:'制动不当'
        },
        {
          value:'202',
          label:'转向不当'
        },
        {
          value:'203',
          label:'油门控制不当'
        },
        {
          value:'204',
          label:'其他操作不当'
        },
        {
          value:'501',
          label:'未设置道路安全措施'
        },
        {
          value:'502',
          label:'安全设施损坏灭失'
        },
        {
          value:'503',
          label:'道路缺陷'
        },
        {
          value:'504',
          label:'其他道路原因'
        },
        {
          value:'601',
          label:'自然灾害'
        },
        {
          value:'602',
          label:'机械故障'
        },
        {
          value:'603',
          label:'爆胎'
        },
        {
          value:'604',
          label:'其他意外'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"是否有优先权",value:'',placeholder:"",name:"whetherThereAPriority",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'没有'
        },
        {
          value:'2',
          label:'有'
        }
      ]
    },
    {label:"道路方向",value:'',placeholder:"",name:"roadDirection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'0',
          label:'停着不动'
        },
        {
          value:'1',
          label:'直线'
        },
        {
          value:'2',
          label:'左转直线'
        },
        {
          value:'3',
          label:'右转曲线'
        },
        {
          value:'4',
          label:'S型曲线'
        }
      ]
    },
    {label:"行车记录仪数据",value:'',placeholder:"",name:"vehicleRecordData",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，未读取到'
        },
        {
          value:'3',
          label:'有，读取到'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"EDR数据",value:'',placeholder:"",name:"edrData",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，未读取到'
        },
        {
          value:'3',
          label:'有，读取到'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"事故前车辆要避撞的对象",value:'',placeholder:"",name:"objectAvoidCollisionBeforeAccident",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'道路上的物品'
        },
        {
          value:'2',
          label:'极差（极颠簸）的路面'
        },
        {
          value:'3',
          label:'道路上的动物'
        },
        {
          value:'4',
          label:'道路上的车辆'
        },
        {
          value:'5',
          label:'道路上的非机动车'
        },
        {
          value:'6',
          label:'肇事逃逸'
        },
        {
          value:'7',
          label:'驾驶员不在场'
        },
        {
          value:'8',
          label:'其他避撞措施'
        },
        {
          value:'9',
          label:'未知'
        },

        {
          value:'10',
          label:'没有避撞措施'
        },
        {
          value:'11',
          label:'与来车无直接接触'
        }
      ]
    },
    {label:"事故前车辆的避撞行为",value:'',placeholder:"",name:"collisionAvoidanceBehaviorOfFrontVehicle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'驾驶员不在场'
        },
        {
          value:'2',
          label:'没有避撞措施'
        },
        {
          value:'3',
          label:'刹车'
        },
        {
          value:'4',
          label:'释放刹车踏板'
        },
        {
          value:'5',
          label:'转向'
        },
        {
          value:'6',
          label:'刹车并转向'
        },
        {
          value:'7',
          label:'加速'
        },
        {
          value:'8',
          label:'加速并转向'
        },
        {
          value:'9',
          label:'其他'
        },
        {
          value:'10',
          label:'未知'
        }
      ],
    },
    {label:"开始反应到碰撞前是否采取转向措施",value:'',placeholder:"",name:"whetherSteeringBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'是'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"碰撞前制动时间",value:'',placeholder:"",name:"brakingTimeBeforeCollision",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，沿道路方向'
        },
        {
          value: '3',
          label: '有，横穿道路方向'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"碰撞前制动距离(m)",value:'',placeholder:"",name:"brakingDistanceBeforeCollision",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，非长期性(如汽车)'
        },
        {
          value: '3',
          label: '有，长期性(如建筑物)'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"车外是否有视野盲区",value:'',placeholder:"车外",name:"blindAreaOutsideCar",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'隔离带造成'
        },
        {
          value:'3',
          label:'路边树木造成'
        },
        {
          value:'4',
          label:'路上放置的牌子造成'
        },
        {
          value:'5',
          label:'车外人员造成'
        },
        {
          value:'6',
          label:'车外其他车辆造成'
        },
        {
          value:'7',
          label:'路上固定建筑物造成'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"车内是否有视野盲区",value:'',placeholder:"车内",name:"blindAreaInCar",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'车身部分造成'
        },
        {
          value:'3',
          label:'遮阳板造成'
        },
        {
          value:'4',
          label:'后视镜造成'
        },
        {
          value:'5',
          label:'头部支撑造成'
        },
        {
          value:'6',
          label:'乘员造成'
        },
        {
          value:'7',
          label:'载货造成'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"碰撞角度",value:'',placeholder:"",name:"collisionAngle",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"第一接触点离最前部距离X(mm)",value:'',placeholder:"",name:"firstContactPointFromFrontX",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"第一接触点离最前部距离Y(mm)",value:'',placeholder:"",name:"firstContactPointFromFrontY",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"第一接触点离地面距离Z(mm)",value:'',placeholder:"",name:"firstContactPointFromFrontZ",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"车辆初始速度(km/h)",value:'',placeholder:"",name:"normalDrivingSpeedBeforeVehicleCollision",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"碰撞时速度(km/h)",value:'',placeholder:"",name:"collisionVelocity",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"EES(km/h)",value:'',placeholder:"",name:"ees",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"delta V(km/h)",value:'',placeholder:"",name:"deltaV",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    }
  ],
  twoWheel:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'1',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*车辆具体种类",value:'',placeholder:"",name:"typeOfParticipant",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'6',
          label:'机动二轮车/三轮车'
        },
        {
          value:'7',
          label:'非机动二轮车/三轮车'
        },
      ]
    },
    {label:"*年龄",value:'',placeholder:"",name:"age",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*性别",value:'',placeholder:"",name:"gender",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value:'1',
          label:'男性'
        },
        {
          value:'2',
          label:'女性'
        },
        {
          value:'3',
          label:'未知'
        }
      ]
    },
    /*与车辆行驶方向的关系*/
    {label:"*与车辆行驶方向的关系",value:'',placeholder:"与车辆行驶方向的关系",name:"relationOfDrivingDirection",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value: '1',
          label: '垂直'
        },
        {
          value: '2',
          label: '同向'
        },
        {
          value: '3',
          label: '相向'
        },
      ]
    },
    /*事故时转向避让反应*/
    {label:"*事故时转向避让反应",value:'',placeholder:"事故时转向避让反应",name:"steeringReactionInAccident",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*事故时二轮车转向灯是否开启*/
    {label:"*事故时二轮车转向灯是否开启",value:'',placeholder:"事故时二轮车转向灯是否开启",name:"whetherTurnSignalOfTwoWheeledVehicleTurned",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*是否有优先权*/
    {label:"*是否有优先权",value:'',placeholder:"是否有优先权",name:"whetherThereAPriority",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*开始反应到碰撞前是否采取转向措施*/
    {label:"*开始反应到碰撞前是否采取转向措施",value:'',placeholder:"开始反应到碰撞前是否采取转向措施",name:"startReactingTakeSteeringMeasures",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*事故发生前车辆运动类型*/
    {label:"*事故发生前车辆运动类型",value:'',placeholder:"事故发生前车辆运动类型",name:"typeVehicleMovementBeforeAccident",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'掉头'
        },
        {
          value:'2',
          label:'向右变道'
        },
        {
          value:'3',
          label:'向左变道'
        },
        {
          value:'4',
          label:'静止'
        },
        {
          value:'5',
          label:'直行加速'
        },
        {
          value:'6',
          label:'直行减速'
        },
        {
          value:'7',
          label:'匀速直行'
        },
        {
          value:'8',
          label:'曲线行驶'
        },
        {
          value:'9',
          label:'左转'
        },
        {
          value:'10',
          label:'右转'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        },

      ]
    },
    /*二轮车乘客数*/
    {label:"*二轮车乘客数",value:'',placeholder:"二轮车乘客数",name:"numberPassengersOnTwoWheelers",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'0'
        },
        {
          value:'2',
          label:'1'
        },
        {
          value:'3',
          label:'2'
        },
        {
          value:'4',
          label:'3'
        },
        {
          value:'5',
          label:'未知'
        },
      ]
    },
    /*二轮车载重*/
    {label:"*二轮车载重(kg)",value:'',placeholder:"二轮车载重",name:"twoWheeledVehicleWeight",type:0,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {

        }
      ]
    },
    {label:"参与方颜色",value:'',placeholder:"",name:"participantColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"长度(mm)",value:'',placeholder:"",name:"vehLength",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"宽度(mm)",value:'',placeholder:"",name:"vehWidth",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"高度(mm)",value:'',placeholder:"",name:"vehHight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"装备质量(kg)",value:'',placeholder:"",name:"weight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"附着系数",value:'',placeholder:"",name:"coeffFrict",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"轴距(cm)",value:'',placeholder:"",name:"wheelbase",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"坐垫离地高度(cm)",value:'',placeholder:"",name:"seatHeightFromTheGround",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"是否为电动车",value:'',placeholder:"",name:"electricVehicleOrNot",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.twoWheel[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"主要过错",value:'',placeholder:"",name:"mainAccidentCause",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'000',
          label:'无过失'
        },
        {
          value:'301',
          label:'超速行驶'
        },
        {
          value:'302',
          label:'酒后驾驶'
        },
        {
          value:'303',
          label:'逆向行驶'
        },
        {
          value:'304',
          label:'违法超车'
        },
        {
          value:'305',
          label:'违法牵引'
        },
        {
          value:'306',
          label:'违法抢行'
        },
        {
          value:'307',
          label:'违法上道路行驶'
        },
        {
          value:'308',
          label:'违法停车'
        },
        {
          value:'309',
          label:'违法占道行驶'
        },
        {
          value:'310',
          label:'违法装载'
        },
        {
          value:'311',
          label:'违反交通信号'
        },
        {
          value:'312',
          label:'未按规定让行'
        },
        {
          value:'313',
          label:'无证驾驶'
        },
        {
          value:'314',
          label:'其他影响安全行为'
        },
        {
          value:'501',
          label:'未设置道路安全措施'
        },
        {
          value:'502',
          label:'安全设施损坏灭失'
        },
        {
          value:'503',
          label:'道路缺陷'
        },
        {
          value:'504',
          label:'其他道路原因'
        },
        {
          value:'601',
          label:'自然灾害'
        },
        {
          value:'602',
          label:'机械故障'
        },
        {
          value:'603',
          label:'爆胎'
        },
        {
          value:'604',
          label:'其他意外'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"二轮车运动方向",value:'',placeholder:"",name:"twoWheelerMovementDirection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '直行'
        },
        {
          value: '2',
          label: '左转'
        },
        {
          value: '3',
          label: '右转'
        },
        {
          value: '4',
          label: '向左变道'
        },
        {
          value: '5',
          label: '向右变道'
        },
        {
          value: '6',
          label: '停车'
        }
      ]
    },
    {label:"二轮车速度(km/h)",value:'',placeholder:"",name:"twoWheelSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"事故时车灯是否开启",value:'',placeholder:"",name:"lightSwitchedOn",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'近光灯'
        },
        {
          value:'3',
          label:'远光灯'
        },
        {
          value:'999',
          label:'未知'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"第一碰撞位置相对自身方位",value:'',placeholder:"",name:"orientationOfFirstCollisionPositionOfTwoWheeledVehicle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'1点钟方向'
        },
        {
          value:'2',
          label:'2点钟方向'
        },
        {
          value:'3',
          label:'3点钟方向'
        },
        {
          value:'4',
          label:'4点钟方向'
        },
        {
          value:'5',
          label:'5点钟方向'
        },
        {
          value:'6',
          label:'6点钟方向'
        },
        {
          value:'7',
          label:'7点钟方向'
        },
        {
          value:'8',
          label:'8点钟方向'
        },
        {
          value:'9',
          label:'9点钟方向'
        },
        {
          value:'10',
          label:'10点钟方向'
        },
        {
          value:'11',
          label:'11点钟方向'
        },
        {
          value:'12',
          label:'12点钟方向'
        },
        {
          value:'13',
          label:'碰撞前已摔倒在地面'
        }
      ]
    },
    {label:"衣着颜色",value:'',placeholder:"",name:"clothingColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"是否戴头盔",value:'',placeholder:"",name:"wearHelmet",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.twoWheel[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"头盔颜色",value:'',placeholder:"",name:"helmetColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橘色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'未知'
        }
      ]
    },
    {label:"在黑暗处或夜间衣物可见性",value:'',placeholder:"",name:"conspicuousnessOfClothingInTheDark",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'明亮的'
        },
        {
          value:'2',
          label:'深色的/不可见'
        },
        {
          value:'3',
          label:'反光的'
        },
        {
          value:'4',
          label:'发光的'
        },
        {
          value:'888',
          label:'其他'
        }
      ]
    }
  ],
  twoWheel_copy:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'1',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*车辆具体种类",value:'',placeholder:"",name:"typeOfParticipant",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'6',
          label:'机动二轮车/三轮车'
        },
        {
          value:'7',
          label:'非机动二轮车/三轮车'
        },
      ]
    },
    {label:"*年龄",value:'',placeholder:"",name:"age",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*性别",value:'',placeholder:"",name:"gender",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value:'1',
          label:'男性'
        },
        {
          value:'2',
          label:'女性'
        },
        {
          value:'3',
          label:'未知'
        }
      ]
    },
    /*与车辆行驶方向的关系*/
    {label:"*与车辆行驶方向的关系",value:'',placeholder:"与车辆行驶方向的关系",name:"relationOfDrivingDirection",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value: '1',
          label: '垂直'
        },
        {
          value: '2',
          label: '同向'
        },
        {
          value: '3',
          label: '相向'
        },
      ]
    },
    /*事故时转向避让反应*/
    {label:"*事故时转向避让反应",value:'',placeholder:"事故时转向避让反应",name:"steeringReactionInAccident",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*事故时二轮车转向灯是否开启*/
    {label:"*事故时二轮车转向灯是否开启",value:'',placeholder:"事故时二轮车转向灯是否开启",name:"whetherTurnSignalOfTwoWheeledVehicleTurned",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*是否有优先权*/
    {label:"*是否有优先权",value:'',placeholder:"是否有优先权",name:"whetherThereAPriority",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*开始反应到碰撞前是否采取转向措施*/
    {label:"*开始反应到碰撞前是否采取转向措施",value:'',placeholder:"开始反应到碰撞前是否采取转向措施",name:"startReactingTakeSteeringMeasures",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*事故发生前车辆运动类型*/
    {label:"*事故发生前车辆运动类型",value:'',placeholder:"事故发生前车辆运动类型",name:"typeVehicleMovementBeforeAccident",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'掉头'
        },
        {
          value:'2',
          label:'向右变道'
        },
        {
          value:'3',
          label:'向左变道'
        },
        {
          value:'4',
          label:'静止'
        },
        {
          value:'5',
          label:'直行加速'
        },
        {
          value:'6',
          label:'直行减速'
        },
        {
          value:'7',
          label:'匀速直行'
        },
        {
          value:'8',
          label:'曲线行驶'
        },
        {
          value:'9',
          label:'左转'
        },
        {
          value:'10',
          label:'右转'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        },

      ]
    },
    /*二轮车乘客数*/
    {label:"*二轮车乘客数",value:'',placeholder:"二轮车乘客数",name:"numberPassengersOnTwoWheelers",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'0'
        },
        {
          value:'2',
          label:'1'
        },
        {
          value:'3',
          label:'2'
        },
        {
          value:'4',
          label:'3'
        },
        {
          value:'5',
          label:'未知'
        },
      ]
    },
    /*二轮车载重*/
    {label:"*二轮车载重(kg)",value:'',placeholder:"二轮车载重",name:"twoWheeledVehicleWeight",type:0,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data1.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {

        }
      ]
    },
    {label:"参与方颜色",value:'',placeholder:"",name:"participantColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"长度(mm)",value:'',placeholder:"",name:"vehLength",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"宽度(mm)",value:'',placeholder:"",name:"vehWidth",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"高度(mm)",value:'',placeholder:"",name:"vehHight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"装备质量(kg)",value:'',placeholder:"",name:"weight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"附着系数",value:'',placeholder:"",name:"coeffFrict",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"轴距(cm)",value:'',placeholder:"",name:"wheelbase",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"坐垫离地高度(cm)",value:'',placeholder:"",name:"seatHeightFromTheGround",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"是否为电动车",value:'',placeholder:"",name:"electricVehicleOrNot",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.twoWheel_copy[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"主要过错",value:'',placeholder:"",name:"mainAccidentCause",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'000',
          label:'无过失'
        },
        {
          value:'301',
          label:'超速行驶'
        },
        {
          value:'302',
          label:'酒后驾驶'
        },
        {
          value:'303',
          label:'逆向行驶'
        },
        {
          value:'304',
          label:'违法超车'
        },
        {
          value:'305',
          label:'违法牵引'
        },
        {
          value:'306',
          label:'违法抢行'
        },
        {
          value:'307',
          label:'违法上道路行驶'
        },
        {
          value:'308',
          label:'违法停车'
        },
        {
          value:'309',
          label:'违法占道行驶'
        },
        {
          value:'310',
          label:'违法装载'
        },
        {
          value:'311',
          label:'违反交通信号'
        },
        {
          value:'312',
          label:'未按规定让行'
        },
        {
          value:'313',
          label:'无证驾驶'
        },
        {
          value:'314',
          label:'其他影响安全行为'
        },
        {
          value:'501',
          label:'未设置道路安全措施'
        },
        {
          value:'502',
          label:'安全设施损坏灭失'
        },
        {
          value:'503',
          label:'道路缺陷'
        },
        {
          value:'504',
          label:'其他道路原因'
        },
        {
          value:'601',
          label:'自然灾害'
        },
        {
          value:'602',
          label:'机械故障'
        },
        {
          value:'603',
          label:'爆胎'
        },
        {
          value:'604',
          label:'其他意外'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"二轮车运动方向",value:'',placeholder:"",name:"twoWheelerMovementDirection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '直行'
        },
        {
          value: '2',
          label: '左转'
        },
        {
          value: '3',
          label: '右转'
        },
        {
          value: '4',
          label: '向左变道'
        },
        {
          value: '5',
          label: '向右变道'
        },
        {
          value: '6',
          label: '停车'
        }
      ]
    },
    {label:"二轮车速度(km/h)",value:'',placeholder:"",name:"twoWheelSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"事故时车灯是否开启",value:'',placeholder:"",name:"lightSwitchedOn",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'近光灯'
        },
        {
          value:'3',
          label:'远光灯'
        },
        {
          value:'999',
          label:'未知'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"第一碰撞位置相对自身方位",value:'',placeholder:"",name:"orientationOfFirstCollisionPositionOfTwoWheeledVehicle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'1点钟方向'
        },
        {
          value:'2',
          label:'2点钟方向'
        },
        {
          value:'3',
          label:'3点钟方向'
        },
        {
          value:'4',
          label:'4点钟方向'
        },
        {
          value:'5',
          label:'5点钟方向'
        },
        {
          value:'6',
          label:'6点钟方向'
        },
        {
          value:'7',
          label:'7点钟方向'
        },
        {
          value:'8',
          label:'8点钟方向'
        },
        {
          value:'9',
          label:'9点钟方向'
        },
        {
          value:'10',
          label:'10点钟方向'
        },
        {
          value:'11',
          label:'11点钟方向'
        },
        {
          value:'12',
          label:'12点钟方向'
        },
        {
          value:'13',
          label:'碰撞前已摔倒在地面'
        }
      ]
    },
    {label:"衣着颜色",value:'',placeholder:"",name:"clothingColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"是否戴头盔",value:'',placeholder:"",name:"wearHelmet",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data1.twoWheel_copy[index].options = this.a.data1.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"头盔颜色",value:'',placeholder:"",name:"helmetColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橘色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'未知'
        }
      ]
    },
    {label:"在黑暗处或夜间衣物可见性",value:'',placeholder:"",name:"conspicuousnessOfClothingInTheDark",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'明亮的'
        },
        {
          value:'2',
          label:'深色的/不可见'
        },
        {
          value:'3',
          label:'反光的'
        },
        {
          value:'4',
          label:'发光的'
        },
        {
          value:'888',
          label:'其他'
        }
      ]
    }
  ]
};

/*对象的深复制*/
let copy = function c(d) {
  let n = new d.constructor();
  for (let k in d) {
    if (d.hasOwnProperty(k)){
      let v = d[k];
      n[k] = typeof v === 'object' ? c(v) : v;
    }
  }
  return n;
};

/*导出数据中详情按钮的弹出框渲染*/
let data2 = copy(data1);


/*数据管理中的弹出框渲染*/
let data3 ={
  total:[
    {
      label: "*事故编号", value: '', placeholder: "事故编号", name: "caseNumber", type: 0, warning: 0, warningMsg: "1", readonly: false,
      blur: ((index) => {
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    /*委托编号*/
    {
      label: "*委托编号", value: '', placeholder: "委托编号", name: "commissionNumber", type: 0, warning: 0, warningMsg: "1", readonly: false,
      blur: ((index) => {
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {
      label: "*事故具体类型", value: '', placeholder: "事故具体类型", name: "accidentType", type: 0, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {
      label: "*参与方总数", value: '', placeholder: "", name: "participantsNum", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '1'
        },
        {
          value: '2',
          label: '2'
        }
      ]
    },
    {
      label: "*事故形态", value: '',placeholder: "", name: "accidentForm", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '人与汽车相撞'
        },
        {
          value: '2',
          label: '非机动车与汽车相撞'
        },
        {
          value: '3',
          label: '机动二/三轮车与汽车相撞'
        },
        {
          value: '4',
          label: '汽车单车事故'
        },
        {
          value: '5',
          label: '汽车撞静止车辆'
        },
        {
          value: '6',
          label: '汽车与汽车正面相撞'
        },
        {
          value: '7',
          label: '汽车与汽车侧门相撞'
        },
        {
          value: '8',
          label: '汽车与汽车尾随相撞'
        },
        {
          value: '9',
          label: '汽车与汽车对向刮撞'
        },
        {
          value: '10',
          label: '汽车与汽车同向刮撞'
        },
        {
          value: '11',
          label: '特殊事故形态'
        }
      ]
    },
    {
      label: "*障碍物类型", value: '', placeholder: "", name: "obstacleType", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '中央隔离带'
        },
        {
          value: '3',
          label: '路边树木/路灯杆'
        },
        {
          value: '4',
          label: '路上放置的牌子'
        },
        {
          value: '5',
          label: '路上的施工围栏'
        },
        {
          value: '6',
          label: '路上固定建筑物'
        },
        {
          value: '7',
          label: '路上临时建筑物'
        },
        {
          value: '8',
          label: '动态障碍物'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {
      label: "*天网及其他视频", value: '', placeholder: "",name: "otherVideo", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '天网监控视频'
        },
        {
          value: '2',
          label: '其他监控视频'
        },
        {
          value: '3',
          label: '无监控视频'
        }
      ]
    },
    {
      label: "*事故分类", value: '', placeholder: "", name: "classificationOfAccidents", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '轻微事故'
        },
        {
          value: '2',
          label: '一般事故'
        },
        {
          value: '3',
          label: '重大事故'
        },
        {
          value: '4',
          label: '特大事故'
        }
      ]
    },
    /*场景类别暂无*/
    {
      label: "*参与方类别", value: '', placeholder: "参与方类别",name: "typeOfParticipants", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '车—人'
        },
        {
          value: '2',
          label: '车—车'
        },
        {
          value: '3',
          label: '车—二轮车'
        }
      ]
    },
    {
      label: "*目标与主车行驶方向关系", value: '', placeholder: "",name: "relationshipBetweenTargetAndDirection", type: 1, warning: 0, warningMsg: "", readonly: false,
      blur: ((index) => {
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{

      }),
      changes:((index)=>{
        let data = this.a.data3.total[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '左方来车'
        },
        {
          value: '2',
          label: '右方来车'
        },
        {
          value: '3',
          label: '对向来车'
        },
        {
          value: '4',
          label: '同向行驶'
        }
      ]
    },
  ],
  env:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      blur: ((index) => {
        let data = this.a.data3.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data3.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*事故地点",value:'',placeholder:"事故地点",name:"accidentAddress",type:0,warning:0,warningMsg:"",readonly:false,
      blur: ((index) => {
        let data = this.a.data3.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data3.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*路段信息",value:'',placeholder:"",name:"roadInformation",type:1,warning:0,warningMsg:"",readonly:false,
      blur: ((index) => {
        let data = this.a.data3.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data3.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value: '1',
          label: '三枝分叉口'
        },
        {
          value: '2',
          label: '四枝分叉口'
        },
        {
          value: '3',
          label: '多枝分叉口'
        },
        {
          value: '4',
          label: '环形交叉'
        },
        {
          value: '5',
          label: '匝道口'
        },
        {
          value: '6',
          label: '普通路段'
        },
        {
          value: '7',
          label: '高架路段'
        },
        {
          value: '8',
          label: '变窄路段'
        },
        {
          value: '9',
          label: '窄路'
        },
        {
          value: '10',
          label: '桥梁'
        },
        {
          value: '11',
          label: '隧道'
        },
        {
          value: '12',
          label: '路段进出处'
        },
        {
          value: '13',
          label: '路侧险要路段'
        },
        {
          value: '14',
          label: '左转弯路段'
        },
        {
          value: '15',
          label: '右转弯路段'
        },
        {
          value: '16',
          label: '变宽路段'
        }
        ,
        {
          value: '17',
          label: '其他特殊路段'
        }
      ]
    },
    {label:"*天气",value:'',placeholder:"",name:"weather",type:1,warning:0,warningMsg:"",readonly:false,
      blur: ((index) => {
        let data = this.a.data3.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data3.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '晴'
        },
        {
          value: '2',
          label: '阴'
        },
        {
          value: '3',
          label: '雨'
        },
        {
          value: '4',
          label: '雪'
        },
        {
          value: '5',
          label: '雾'
        },
        {
          value: '6',
          label: '大风'
        },
        {
          value: '7',
          label: '沙尘'
        },
        {
          value: '8',
          label: '冰雹'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"*事故发生时段",value:'',placeholder:"",name:"periodOfAccident",type:1,warning:0,warningMsg:"",readonly:false,
      blur: ((index) => {
        let data = this.a.data3.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
        let data = this.a.data3.env[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value: '1',
          label: '日间'
        },
        {
          value: '2',
          label: '夜间'
        },
        {
          value: '3',
          label: '晨昏'
        }
      ]
    },
    {label:"照明情况",value:'',placeholder:"",name:"lightingSituation",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '1',
          label: '良好'
        },
        {
          value: '2',
          label: '差，对事故产生一定影响'
        },
        {
          value: '3',
          label: '未知'
        }
      ]
    },
    {label:"日间太阳光线",value:'',placeholder:"",name:"lightCondition",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '1',
          label: '太阳光线较强'
        },
        {
          value: '2',
          label: '太阳光线一般'
        },
        {
          value: '3',
          label: '太阳光线较弱'
        }
      ]
    },
    {label:"雾天的能见度",value:'',placeholder:"",name:"visibilityInFog",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '1',
          label: '小于50米（强浓雾）'
        },
        {
          value: '2',
          label: '小于200米（浓雾）'
        },
        {
          value: '3',
          label: '小于500米（大雾）'
        },
        {
          value: '4',
          label: '小于1000米（雾）'
        },
        {
          value: '5',
          label: '1-10公里（轻雾）'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"降水量",value:'',placeholder:"",name:"precipitation",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '1',
          label: '小雨'
        },
        {
          value: '2',
          label: '中雨'
        },
        {
          value: '3',
          label: '大雨'
        },
        {
          value: '4',
          label: '暴雨'
        },
        {
          value: '5',
          label: '大暴雨'
        },
        {
          value: '6',
          label: '特大暴雨'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"降雪量",value:'',placeholder:"",name:"snowfall",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '1',
          label: '小雪'
        },
        {
          value: '2',
          label: '中雪'
        },
        {
          value: '3',
          label: '大雪'
        },
        {
          value: '4',
          label: '暴雪'
        },
        {
          value: '5',
          label: '大暴雪'
        },
        {
          value: '6',
          label: '特大暴雪'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"摄氏温度(℃)",value:'',placeholder:"",name:"temperature",type:0,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {}
      ]
    },
    {label:"风速",value:'',placeholder:"",name:"windSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {}
      ]
    },
    {label:"风级",value:'',placeholder:"",name:"windLevel",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '0',
          label: '0'
        },
        {
          value: '1',
          label: '1'
        },
        {
          value: '2',
          label: '2'
        },
        {
          value: '3',
          label: '3'
        },
        {
          value: '4',
          label: '4'
        },
        {
          value: '5',
          label: '5'
        },
        {
          value: '6',
          label: '6'
        },
        {
          value: '7',
          label: '7'
        }
        ,
        {
          value: '8',
          label: '8'
        },
        {
          value: '9',
          label: '9'
        },
        {
          value: '10',
          label: '10'
        },
        {
          value: '11',
          label: '11'
        },
        {
          value: '12',
          label: '12'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"风向",value:'',placeholder:"",name:"windDirection",type:1,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '1',
          label: '北'
        },
        {
          value: '2',
          label: '东北'
        },
        {
          value: '3',
          label: '东'
        },
        {
          value: '4',
          label: '东南'
        },
        {
          value: '5',
          label: '南'
        },
        {
          value: '6',
          label: '西南'
        },
        {
          value: '7',
          label: '西'
        },
        {
          value: '8',
          label: '西北'
        },
        {
          value: '999',
          label: '未知'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"经度",value:'',placeholder:"",name:"eastLongitude",type:0,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {}
      ]
    },
    {label:"纬度",value:'',placeholder:"",name:"northLatitude",type:0,warning:0,warningMsg:"",readonly:false,
      blur:((index)=>{

      }),
      focus:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {}
      ]
    }
  ],
  road:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'1',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*参与方道路所在名称",value:'',placeholder:"",name:"roadName",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    /*是否为变宽路段*/
    {label:"*是否为变宽路段",value:'',placeholder:"是否为变宽路段",name:"whetherItIsAWidenedSection",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'999-未知'
        },
      ]
    },
    /*是否有为变窄路段*/
    {label:"*是否为变窄路段",value:'',placeholder:"是否有为变窄路段",name:"whetherThereANarrowSection",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'未知'
        },
      ]
    },
    /*是否有隧道*/
    {label:"*是否有隧道",value:'',placeholder:"是否有隧道",name:"whetherThereATunnel",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'未知'
        },
      ]
    },
    /*是否为匝道口*/
    {label:"*是否为匝道口",value:'',placeholder:"是否为匝道口",name:"whetherItARamp",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'未知'
        },
      ]
    },
    {label:"事故地点道路走向",value:'',placeholder:"",name:"directionRoadAtCollisionPoint",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '南北'
        },
        {
          value: '2',
          label: '东西'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"道路行政等级",value:'',placeholder:"",name:"administrativeRankOfRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '公路'
        },
        {
          value: '2',
          label: '城市道路'
        },
        {
          value: '3',
          label: '厂矿道路'
        },
        {
          value: '4',
          label: '林区道路'
        },
        {
          value: '5',
          label: '乡村道路'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"公路等级",value:'',placeholder:"",name:"classOfRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '高速公路'
        },
        {
          value: '2',
          label: '一级公路'
        },
        {
          value: '3',
          label: '二级公路'
        },
        {
          value: '4',
          label: '三级公路'
        },
        {
          value: '5',
          label: '四级公路'
        },
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"城市道路类型",value:'',placeholder:"",name:"typeOfCityRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '快速路'
        },
        {
          value: '2',
          label: '主干路'
        },
        {
          value: '3',
          label: '次干路'
        },
        {
          value: '4',
          label: '支路'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"整体机动车道数（条）",value:'',placeholder:"",name:"totalNumberOfMotorVehicleLanes",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"东侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnEastSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"西侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnWestSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"南侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnSouthSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"北侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnNorthSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"非机动车道（东西）",value:'',placeholder:"",name:"nonMotorVehicleLaneOfEastWest",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '仅东侧'
        },
        {
          value: '3',
          label: '仅西侧'
        },
        {
          value: '4',
          label: '两侧均有'
        }
      ]
    },
    {label:"非机动车道（南北）",value:'',placeholder:"",name:"nonMotorVehicleLaneOfSouthNorth",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '仅南侧'
        },
        {
          value: '3',
          label: '仅北侧'
        },
        {
          value: '4',
          label: '两侧均有'
        }
      ]
    },
    {label:"道路横截面的轮廓",value:'',placeholder:"",name:"outlineOfRoadCrossSection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有横向的倾斜'
        },
        {
          value: '2',
          label: '拱形'
        },
        {
          value: '3',
          label: '向一侧横向倾斜'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"对向机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfOppositeVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有隔离'
        },
        {
          value: '2',
          label: '单虚线'
        },
        {
          value: '3',
          label: '单实线'
        },
        {
          value: '4',
          label: '双实线'
        },
        {
          value: '5',
          label: '中央绿化带'
        },
        {
          value: '6',
          label: '隔离栅栏'
        },
        {
          value: '7',
          label: '单向道'
        },
        {
          value: '8',
          label: '石墩隔离'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"东侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfEastNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfWestNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfSourthNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfNorthNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"道路总宽度(m)",value:'',placeholder:"",name:"overallWidthOfRoad",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"道路的线形",value:'',placeholder:"",name:"theLinearShapeOfTheRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平直'
        },
        {
          value: '2',
          label: '一般弯'
        },
        {
          value: '3',
          label: '一般坡'
        },
        {
          value: '4',
          label: '急弯'
        },
        {
          value: '5',
          label: '陡坡'
        },
        {
          value: '6',
          label: '连续下坡'
        },
        {
          value: '7',
          label: '一般弯坡'
        },
        {
          value: '8',
          label: '急弯陡坡'
        },
        {
          value: '9',
          label: '一般坡急弯'
        },
        {
          value: '10',
          label: '一般弯陡坡'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"曲率半径(m)",value:'',placeholder:"",name:"radiusOfCurve",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"沿道路方向的趋势",value:'',placeholder:"",name:"trendsAlongTheRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平坦的'
        },
        {
          value: '2',
          label: '上升'
        },
        {
          value: '3',
          label: '下降'
        }
      ]
    },
    {label:"该趋势的坡度(%)",value:'',placeholder:"",name:"slopeOfTheTrend",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"最高允许车速(km/h)",value:'',placeholder:"",name:"maximumAllowedSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"路面材料",value:'',placeholder:"",name:"typeOfRoadSurface",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '沥青'
        },
        {
          value: '2',
          label: '水泥'
        },
        {
          value: '3',
          label: '沙石'
        },
        {
          value: '4',
          label: '土路'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"道路表面污染",value:'',placeholder:"",name:"surfaceFouling",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '否'
        },
        {
          value: '2',
          label: '油'
        },
        {
          value: '3',
          label: '燃料'
        },
        {
          value: '4',
          label: '污垢'
        },
        {
          value: '5',
          label: '石头'
        },
        {
          value: '6',
          label: '掉落的货物'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"路表潮湿度",value:'',placeholder:"",name:"roadSurfaceHumidity",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '干'
        },
        {
          value: '2',
          label: '湿'
        },
        {
          value: '3',
          label: '冰冻'
        },
        {
          value: '4',
          label: '积雪'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"路面状况",value:'',placeholder:"",name:"roadCondition",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平坦'
        },
        {
          value: '2',
          label: '有凹槽'
        },
        {
          value: '3',
          label: '排水槽'
        },
        {
          value: '4',
          label: '松动的路表'
        },
        {
          value: '5',
          label: '搓衣板状'
        },
        {
          value: '6',
          label: '坑洼'
        },
        {
          value: '7',
          label: '波浪状'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"交通标志是否被遮挡",value:'',placeholder:"",name:"trafficSignsNotVisible",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无交通标志'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '3',
          label: '是，因为植物'
        },
        {
          value: '4',
          label: '是，因为建筑'
        },
        {
          value: '5',
          label: '是，因为车辆'
        },
        {
          value: '6',
          label: '是，因为天气'
        },
        {
          value: '888',
          label: '是，其他'
        }
      ]
    },
    {label:"路口信号灯",value:'',placeholder:"",name:"intersectionSignalLamp",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有'
        },
        {
          value: '2',
          label: '仅有直行信号灯'
        },
        {
          value: '3',
          label: '有直行和转弯信号灯'
        }
      ]
    },
    {label:"现场交通警告标志",value:'',placeholder:"",name:"trafficWarningSign",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"现场交通禁令标志",value:'',placeholder:"",name:"trafficBanSign",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"路灯是否开启",value:'',placeholder:"",name:"streetLighting",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无路灯'
        },
        {
          value: '2',
          label: '有，点亮'
        },
        {
          value: '3',
          label: '有，关闭'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ],
    },
    {label:"路灯密度",value:'',placeholder:"",name:"densityOfStreetLighting",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '稀少的路灯'
        },
        {
          value: '2',
          label: '成列的路灯'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"是否有轨道",value:'',placeholder:"",name:"railsInRoadSurface",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，沿道路方向'
        },
        {
          value: '3',
          label: '有，横穿道路方向'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"影响视线障碍物",value:'',placeholder:"",name:"viewObstacle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，非长期性(如汽车)'
        },
        {
          value: '3',
          label: '有，长期性(如建筑物)'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"道路状况评估",value:'',placeholder:"",name:"roadConditionRating",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '状况良好'
        },
        {
          value: '2',
          label: '差，对交通有影响'
        },
        {
          value: '3',
          label: '差，对交通无影响'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"是否有建筑设施",value:'',placeholder:"",name:"constructionFacilities",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有'
        },
        {
          value: '2',
          label: '因有建筑工地路面变窄'
        },
        {
          value: '3',
          label: '因有建筑工地而改变道路路线'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"交通限速设施",value:'',placeholder:"",name:"trafficSpeedLimitingFacilities",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有'
        },
        {
          value: '2',
          label: '单一凸起减速带'
        },
        {
          value: '3',
          label: '密集凸起圆点减速带'
        },
        {
          value: '4',
          label: '只有限速标志'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"车辆是否冲到相应路边",value:'',placeholder:"",name:"vehiclesRushedToCorrespondingRoadside",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '否'
        },
        {
          value: '2',
          label: '是'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"东侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnEastSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"东侧车道边缘地面",value:'',placeholder:"",name:"eastSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"东侧车道边缘高度",value:'',placeholder:"",name:"eastSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnWestSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧道路边缘地面",value:'',placeholder:"",name:"westSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧道路边缘高度",value:'',placeholder:"",name:"westSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnSouthSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧道路边缘地面",value:'',placeholder:"",name:"southSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧道路边缘高度",value:'',placeholder:"",name:"southSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
      }),
      blur:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnNorthSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧道路边缘地面",value:'',placeholder:"",name:"northSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧道路边缘高度",value:'',placeholder:"",name:"northSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"车辆是否跌入水沟",value:'',placeholder:"",name:"vehicleFellIntoDitch",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '否'
        },
        {
          value: '2',
          label: '是'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"水沟深(cm)",value:'',placeholder:"",name:"ditchDepth",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"所在车道宽度(m)",value:'',placeholder:"",name:"widthOfLane",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"照明",value:'',placeholder:"",name:"lighting",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    }
  ],
  road_copy:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'2',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*参与方道路所在名称",value:'',placeholder:"",name:"roadName",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    /*是否为变宽路段*/
    {label:"*是否为变宽路段",value:'',placeholder:"是否为变宽路段",name:"whetherItIsAWidenedSection",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'999-未知'
        },
      ]
    },
    /*是否有为变窄路段*/
    {label:"*是否为变窄路段",value:'',placeholder:"是否有为变窄路段",name:"whetherThereANarrowSection",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'未知'
        },
      ]
    },
    /*是否有隧道*/
    {label:"*是否有隧道",value:'',placeholder:"是否有隧道",name:"whetherThereATunnel",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'未知'
        },
      ]
    },
    /*是否为匝道口*/
    {label:"*是否为匝道口",value:'',placeholder:"是否为匝道口",name:"whetherItARamp",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.road_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'未知'
        },
      ]
    },
    {label:"事故地点道路走向",value:'',placeholder:"",name:"directionRoadAtCollisionPoint",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '南北'
        },
        {
          value: '2',
          label: '东西'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"道路行政等级",value:'',placeholder:"",name:"administrativeRankOfRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '公路'
        },
        {
          value: '2',
          label: '城市道路'
        },
        {
          value: '3',
          label: '厂矿道路'
        },
        {
          value: '4',
          label: '林区道路'
        },
        {
          value: '5',
          label: '乡村道路'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"公路等级",value:'',placeholder:"",name:"classOfRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '高速公路'
        },
        {
          value: '2',
          label: '一级公路'
        },
        {
          value: '3',
          label: '二级公路'
        },
        {
          value: '4',
          label: '三级公路'
        },
        {
          value: '5',
          label: '四级公路'
        },
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"城市道路类型",value:'',placeholder:"",name:"typeOfCityRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '快速路'
        },
        {
          value: '2',
          label: '主干路'
        },
        {
          value: '3',
          label: '次干路'
        },
        {
          value: '4',
          label: '支路'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"整体机动车道数（条）",value:'',placeholder:"",name:"totalNumberOfMotorVehicleLanes",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"东侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnEastSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"西侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnWestSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"南侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnSouthSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"北侧机动车道数（条）",value:'',placeholder:"",name:"numberVehicleLanesOnNorthSide",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"非机动车道（东西）",value:'',placeholder:"",name:"nonMotorVehicleLaneOfEastWest",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '仅东侧'
        },
        {
          value: '3',
          label: '仅西侧'
        },
        {
          value: '4',
          label: '两侧均有'
        }
      ]
    },
    {label:"非机动车道（南北）",value:'',placeholder:"",name:"nonMotorVehicleLaneOfSouthNorth",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '仅南侧'
        },
        {
          value: '3',
          label: '仅北侧'
        },
        {
          value: '4',
          label: '两侧均有'
        }
      ]
    },
    {label:"道路横截面的轮廓",value:'',placeholder:"",name:"outlineOfRoadCrossSection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有横向的倾斜'
        },
        {
          value: '2',
          label: '拱形'
        },
        {
          value: '3',
          label: '向一侧横向倾斜'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"对向机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfOppositeVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有隔离'
        },
        {
          value: '2',
          label: '单虚线'
        },
        {
          value: '3',
          label: '单实线'
        },
        {
          value: '4',
          label: '双实线'
        },
        {
          value: '5',
          label: '中央绿化带'
        },
        {
          value: '6',
          label: '隔离栅栏'
        },
        {
          value: '7',
          label: '单向道'
        },
        {
          value: '8',
          label: '石墩隔离'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"东侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfEastNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfWestNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfSourthNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧非机动车道隔离形式",value:'',placeholder:"",name:"isolationFormOfNorthNoMotorVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单虚线'
        },
        {
          value: '2',
          label: '单实线'
        },
        {
          value: '3',
          label: '绿化带'
        },
        {
          value: '4',
          label: '护栏'
        },
        {
          value: '5',
          label: '石墩隔离'
        },
        {
          value: '6',
          label: '提示杆'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"道路总宽度(m)",value:'',placeholder:"",name:"overallWidthOfRoad",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"道路的线形",value:'',placeholder:"",name:"theLinearShapeOfTheRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平直'
        },
        {
          value: '2',
          label: '一般弯'
        },
        {
          value: '3',
          label: '一般坡'
        },
        {
          value: '4',
          label: '急弯'
        },
        {
          value: '5',
          label: '陡坡'
        },
        {
          value: '6',
          label: '连续下坡'
        },
        {
          value: '7',
          label: '一般弯坡'
        },
        {
          value: '8',
          label: '急弯陡坡'
        },
        {
          value: '9',
          label: '一般坡急弯'
        },
        {
          value: '10',
          label: '一般弯陡坡'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"曲率半径(m)",value:'',placeholder:"",name:"radiusOfCurve",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"沿道路方向的趋势",value:'',placeholder:"",name:"trendsAlongTheRoad",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平坦的'
        },
        {
          value: '2',
          label: '上升'
        },
        {
          value: '3',
          label: '下降'
        }
      ]
    },
    {label:"该趋势的坡度(%)",value:'',placeholder:"",name:"slopeOfTheTrend",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"最高允许车速(km/h)",value:'',placeholder:"",name:"maximumAllowedSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"路面材料",value:'',placeholder:"",name:"typeOfRoadSurface",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '沥青'
        },
        {
          value: '2',
          label: '水泥'
        },
        {
          value: '3',
          label: '沙石'
        },
        {
          value: '4',
          label: '土路'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"道路表面污染",value:'',placeholder:"",name:"surfaceFouling",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '否'
        },
        {
          value: '2',
          label: '油'
        },
        {
          value: '3',
          label: '燃料'
        },
        {
          value: '4',
          label: '污垢'
        },
        {
          value: '5',
          label: '石头'
        },
        {
          value: '6',
          label: '掉落的货物'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"路表潮湿度",value:'',placeholder:"",name:"roadSurfaceHumidity",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '干'
        },
        {
          value: '2',
          label: '湿'
        },
        {
          value: '3',
          label: '冰冻'
        },
        {
          value: '4',
          label: '积雪'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"路面状况",value:'',placeholder:"",name:"roadCondition",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平坦'
        },
        {
          value: '2',
          label: '有凹槽'
        },
        {
          value: '3',
          label: '排水槽'
        },
        {
          value: '4',
          label: '松动的路表'
        },
        {
          value: '5',
          label: '搓衣板状'
        },
        {
          value: '6',
          label: '坑洼'
        },
        {
          value: '7',
          label: '波浪状'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"交通标志是否被遮挡",value:'',placeholder:"",name:"trafficSignsNotVisible",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无交通标志'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '3',
          label: '是，因为植物'
        },
        {
          value: '4',
          label: '是，因为建筑'
        },
        {
          value: '5',
          label: '是，因为车辆'
        },
        {
          value: '6',
          label: '是，因为天气'
        },
        {
          value: '888',
          label: '是，其他'
        }
      ]
    },
    {label:"路口信号灯",value:'',placeholder:"",name:"intersectionSignalLamp",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有'
        },
        {
          value: '2',
          label: '仅有直行信号灯'
        },
        {
          value: '3',
          label: '有直行和转弯信号灯'
        }
      ]
    },
    {label:"现场交通警告标志",value:'',placeholder:"",name:"trafficWarningSign",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"现场交通禁令标志",value:'',placeholder:"",name:"trafficBanSign",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"路灯是否开启",value:'',placeholder:"",name:"streetLighting",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无路灯'
        },
        {
          value: '2',
          label: '有，点亮'
        },
        {
          value: '3',
          label: '有，关闭'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ],
    },
    {label:"路灯密度",value:'',placeholder:"",name:"densityOfStreetLighting",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '稀少的路灯'
        },
        {
          value: '2',
          label: '成列的路灯'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"是否有轨道",value:'',placeholder:"",name:"railsInRoadSurface",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，沿道路方向'
        },
        {
          value: '3',
          label: '有，横穿道路方向'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"影响视线障碍物",value:'',placeholder:"",name:"viewObstacle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，非长期性(如汽车)'
        },
        {
          value: '3',
          label: '有，长期性(如建筑物)'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"道路状况评估",value:'',placeholder:"",name:"roadConditionRating",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '状况良好'
        },
        {
          value: '2',
          label: '差，对交通有影响'
        },
        {
          value: '3',
          label: '差，对交通无影响'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"是否有建筑设施",value:'',placeholder:"",name:"constructionFacilities",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有'
        },
        {
          value: '2',
          label: '因有建筑工地路面变窄'
        },
        {
          value: '3',
          label: '因有建筑工地而改变道路路线'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"交通限速设施",value:'',placeholder:"",name:"trafficSpeedLimitingFacilities",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '没有'
        },
        {
          value: '2',
          label: '单一凸起减速带'
        },
        {
          value: '3',
          label: '密集凸起圆点减速带'
        },
        {
          value: '4',
          label: '只有限速标志'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"车辆是否冲到相应路边",value:'',placeholder:"",name:"vehiclesRushedToCorrespondingRoadside",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '否'
        },
        {
          value: '2',
          label: '是'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"东侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnEastSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"东侧车道边缘地面",value:'',placeholder:"",name:"eastSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"东侧车道边缘高度",value:'',placeholder:"",name:"eastSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnWestSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧道路边缘地面",value:'',placeholder:"",name:"westSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"西侧道路边缘高度",value:'',placeholder:"",name:"westSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnSouthSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧道路边缘地面",value:'',placeholder:"",name:"southSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"南侧道路边缘高度",value:'',placeholder:"",name:"southSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
      }),
      blur:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧道路路面布局",value:'',placeholder:"",name:"pavementLayoutOnNorthSide",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '平地表面(包括草地、牧场)'
        },
        {
          value: '2',
          label: '灌木丛'
        },
        {
          value: '3',
          label: '稀疏林立的树木'
        },
        {
          value: '4',
          label: '成排的密度较大的树木'
        },
        {
          value: '5',
          label: '栅栏'
        },
        {
          value: '6',
          label: '防护板'
        },
        {
          value: '7',
          label: '沟渠'
        },
        {
          value: '8',
          label: '向下倾斜的堤坝'
        },
        {
          value: '9',
          label: '向上升的筑堤'
        },
        {
          value: '10',
          label: '围墙'
        },
        {
          value: '11',
          label: '隧道墙'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧道路边缘地面",value:'',placeholder:"",name:"northSideOfDriveway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '石头'
        },
        {
          value: '2',
          label: '碎石路基'
        },
        {
          value: '3',
          label: '草'
        },
        {
          value: '4',
          label: '沙石'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"北侧道路边缘高度",value:'',placeholder:"",name:"northSideLaneEdgeHeight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '同车道一样高'
        },
        {
          value: '2',
          label: '比车道低'
        },
        {
          value: '3',
          label: '比车道高'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"车辆是否跌入水沟",value:'',placeholder:"",name:"vehicleFellIntoDitch",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '否'
        },
        {
          value: '2',
          label: '是'
        },
        {
          value: '000',
          label: '不适用'
        }
      ]
    },
    {label:"水沟深(cm)",value:'',placeholder:"",name:"ditchDepth",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"所在车道宽度(m)",value:'',placeholder:"",name:"widthOfLane",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"照明",value:'',placeholder:"",name:"lighting",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    }
  ],
  yORn:[
    {
      label:"是",
      value:"1"
    },
    {
      label:"否",
      value:"2"
    },
    {
      label:"未知",
      value:"3"
    }
  ],
  nORy:[
    {
      value:'1',
      label:'无'
    },
    {
      value:'2',
      label:'有，关闭'
    },
    {
      value:'3',
      label:'有，开着'
    },
    {
      value:'4',
      label:'有，未知是否使用'
    },
    {
      value:'999',
      label:'未知'
    }
  ],
  gender:[
    {
      label:"男性",
      value:"1"
    },
    {
      label:"女性",
      value:"2"
    },
    {
      label:"孕妇",
      value:"3"
    },
    {
      label:"未知",
      value:"4"
    }
  ],
  person:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'1',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*年龄",value:'',placeholder:"",name:"age",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*性别",value:'',placeholder:"",name:"gender",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value:'1',
          label:'男性'
        },
        {
          value:'2',
          label:'女性'
        },
        {
          value:'3',
          label:'未知'
        }
      ]
    },
    {label:"*高度(身高)(cm)",value:'',placeholder:"",name:"vehHight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*体重(kg)",value:'',placeholder:"",name:"weight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    /*开始反应到碰撞前是否有应急姿态*/
    {label:"*开始反应到碰撞前是否有应急姿态",value:'',placeholder:"开始反应到碰撞前是否有应急姿态",name:"whetherEmergencyPostureBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*行人是否从障碍物后穿出*/
    {label:"*行人是否从障碍物后穿出",value:'',placeholder:"行人是否从障碍物后穿出",name:"whetherPedestriansWearOutFromObstacles",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*行人意识到危险之前是否加速*/
    {label:"*行人意识到危险之前是否加速",value:'',placeholder:"行人意识到危险之前是否加速",name:"whetherPedestriansBeforeTheyAccelerate",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*事故前行人行走方向是否改变*/
    {label:"*事故前行人行走方向是否改变",value:'',placeholder:"事故前行人行走方向是否改变",name:"whetherWalkingDirectionPedestrianChanges",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"行人速度(km/h)",value:'',placeholder:"",name:"pedestrianSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"参与方颜色(衣着颜色)",value:'',placeholder:"",name:"participantColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"黑暗处或夜间衣物可见性",value:'',placeholder:"",name:"visibilityInTheDarkOrAtNight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'明亮的'
        },
        {
          value:'2',
          label:'深色的/不可见'
        },
        {
          value:'3',
          label:'反光的'
        },
        {
          value:'4',
          label:'发光的'
        },
        {
          value:'888',
          label:'其他'
        }
      ]
    },
    {label:"主要过错",value:'',placeholder:"",name:"mainAccidentCause",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'000',
          label:'无过失'
        },
        {
          value:'401',
          label:'违法上道路行驶'
        },
        {
          value:'402',
          label:'违法占道'
        },
        {
          value:'403',
          label:'违法装载超限及危险品运输'
        },
        {
          value:'404',
          label:'违反交通信号'
        },
        {
          value:'405',
          label:'其他影响安全行为'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"事故发生地点(行人被撞地点)",value:'',placeholder:"",name:"accidentLocation",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '人行道'
        },
        {
          value: '2',
          label: '非机动车道'
        },
        {
          value: '3',
          label: '机动车道'
        },
        {
          value: '4',
          label: '高速/高架'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"行人穿越机动车道位置",value:'',placeholder:"",name:"pedestrianCrossingTheMotorwayLocation",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '未穿越'
        },
        {
          value: '2',
          label: '有红绿灯处'
        },
        {
          value: '3',
          label: '斑马线处'
        },
        {
          value: '4',
          label: '行人专用通道'
        },
        {
          value: '5',
          label: '无行人过街保护的机动车道路'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"行人行走方向",value:'',placeholder:"",name:"pedestrianWalkingDirection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '从车辆左侧'
        },
        {
          value: '2',
          label: '从车辆右侧'
        },
        {
          value: '3',
          label: '沿车辆运动方向'
        },
        {
          value: '4',
          label: '静止'
        }
      ]
    },
    {label:"行人运动状态",value:'',placeholder:"",name:"pedestrianMovement",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '静止'
        },
        {
          value: '2',
          label: '缓慢步行'
        },
        {
          value: '3',
          label: '快速步行'
        },
        {
          value: '4',
          label: '跑步'
        },
        {
          value: '5',
          label: '前一次碰撞后非正常运动状态'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"行人被撞部位",value:'',placeholder:"",name:"pedestrianBeingHit",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '前方'
        },
        {
          value: '2',
          label: '后方'
        },
        {
          value: '3',
          label: '左侧'
        },
        {
          value: '4',
          label: '右侧'
        },
        {
          value: '5',
          label: '碰撞前跌倒，躺在地上'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"碰撞前行人相对于车辆的位置",value:'',placeholder:"",name:"positionOfPedestrianRelativeToVehicleBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '前方'
        },
        {
          value: '2',
          label: '后方'
        },
        {
          value: '3',
          label: '左侧'
        },
        {
          value: '4',
          label: '右侧'
        }
      ]
    },
    {label:"穿越机动车道时能否被看到",value:'',placeholder:"",name:"canYouBeSeenWhenCrossingTheMotorway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '可以看见'
        },
        {
          value: '2',
          label: '因停驻的车而看不到'
        },
        {
          value: '3',
          label: '因植物而看不到'
        },
        {
          value: '4',
          label: '因建筑物而看不到'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"是否因为视野盲区造成事故",value:'',placeholder:"",name:"whetherItIsCausedByBlindSpotOfVision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.person[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"是否因为停靠车辆造成行人视野盲区:",value:'',placeholder:"",name:"whetherBlindareaOfPedestrianIsCausedByParkedVehicle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.person[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"是否有其他造成行人视线盲区物体:",value:'',placeholder:"",name:"areThereOtherObjectsThatCausePedestrianBlindSpots",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.person[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '2',
          label: '否'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    }
  ],
  person_copy:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'2',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*年龄",value:'',placeholder:"",name:"age",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*性别",value:'',placeholder:"",name:"gender",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value:'1',
          label:'男性'
        },
        {
          value:'2',
          label:'女性'
        },
        {
          value:'3',
          label:'未知'
        }
      ]
    },
    {label:"*高度(身高)(cm)",value:'',placeholder:"",name:"vehHight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*体重(kg)",value:'',placeholder:"",name:"weight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    /*开始反应到碰撞前是否有应急姿态*/
    {label:"*开始反应到碰撞前是否有应急姿态",value:'',placeholder:"开始反应到碰撞前是否有应急姿态",name:"whetherEmergencyPostureBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*行人是否从障碍物后穿出*/
    {label:"*行人是否从障碍物后穿出",value:'',placeholder:"行人是否从障碍物后穿出",name:"whetherPedestriansWearOutFromObstacles",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*行人意识到危险之前是否加速*/
    {label:"*行人意识到危险之前是否加速",value:'',placeholder:"行人意识到危险之前是否加速",name:"whetherPedestriansBeforeTheyAccelerate",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*事故前行人行走方向是否改变*/
    {label:"*事故前行人行走方向是否改变",value:'',placeholder:"事故前行人行走方向是否改变",name:"whetherWalkingDirectionPedestrianChanges",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.person_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"行人速度(km/h)",value:'',placeholder:"",name:"pedestrianSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"参与方颜色(衣着颜色)",value:'',placeholder:"",name:"participantColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"黑暗处或夜间衣物可见性",value:'',placeholder:"",name:"visibilityInTheDarkOrAtNight",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'明亮的'
        },
        {
          value:'2',
          label:'深色的/不可见'
        },
        {
          value:'3',
          label:'反光的'
        },
        {
          value:'4',
          label:'发光的'
        },
        {
          value:'888',
          label:'其他'
        }
      ]
    },
    {label:"主要过错",value:'',placeholder:"",name:"mainAccidentCause",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'000',
          label:'无过失'
        },
        {
          value:'404',
          label:'违法交通信号'
        },
        {
          value:'2',
          label:'违法上道路行驶'
        },
        {
          value:'3',
          label:'其他影响安全行为'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"事故发生地点(行人被撞地点)",value:'',placeholder:"",name:"accidentLocation",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '人行道'
        },
        {
          value: '2',
          label: '非机动车道'
        },
        {
          value: '3',
          label: '机动车道'
        },
        {
          value: '4',
          label: '高速/高架'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"行人穿越机动车道位置",value:'',placeholder:"",name:"pedestrianCrossingTheMotorwayLocation",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '未穿越'
        },
        {
          value: '2',
          label: '有红绿灯处'
        },
        {
          value: '3',
          label: '斑马线处'
        },
        {
          value: '4',
          label: '行人专用通道'
        },
        {
          value: '5',
          label: '无行人过街保护的机动车道路'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"行人行走方向",value:'',placeholder:"",name:"pedestrianWalkingDirection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '从车辆左侧'
        },
        {
          value: '2',
          label: '从车辆右侧'
        },
        {
          value: '3',
          label: '沿车辆运动方向'
        },
        {
          value: '4',
          label: '静止'
        }
      ]
    },
    {label:"行人运动状态",value:'',placeholder:"",name:"pedestrianMovement",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '静止'
        },
        {
          value: '2',
          label: '缓慢步行'
        },
        {
          value: '3',
          label: '快速步行'
        },
        {
          value: '4',
          label: '跑步'
        },
        {
          value: '5',
          label: '前一次碰撞后非正常运动状态'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"行人被撞部位",value:'',placeholder:"",name:"pedestrianBeingHit",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '前方'
        },
        {
          value: '2',
          label: '后方'
        },
        {
          value: '3',
          label: '左侧'
        },
        {
          value: '4',
          label: '右侧'
        },
        {
          value: '5',
          label: '碰撞前跌倒，躺在地上'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"碰撞前行人相对于车辆的位置",value:'',placeholder:"",name:"positionOfPedestrianRelativeToVehicleBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '前方'
        },
        {
          value: '2',
          label: '后方'
        },
        {
          value: '3',
          label: '左侧'
        },
        {
          value: '4',
          label: '右侧'
        }
      ]
    },
    {label:"穿越机动车道时能否被看到",value:'',placeholder:"",name:"canYouBeSeenWhenCrossingTheMotorway",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '可以看见'
        },
        {
          value: '2',
          label: '因停驻的车而看不到'
        },
        {
          value: '3',
          label: '因植物而看不到'
        },
        {
          value: '4',
          label: '因建筑物而看不到'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"是否因为视野盲区造成事故",value:'',placeholder:"",name:"whetherItIsCausedByBlindSpotOfVision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.person_copy[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否因为停靠车辆造成行人视野盲区:",value:'',placeholder:"",name:"whetherBlindareaOfPedestrianIsCausedByParkedVehicle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.person_copy[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{
      }),
      changes:((index)=>{
      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有其他造成行人视线盲区物体:",value:'',placeholder:"",name:"areThereOtherObjectsThatCausePedestrianBlindSpots",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.person_copy[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    }
  ],
  car:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'1',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*车辆类型",value:'',placeholder:"",name:"typeOfParticipant",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'乘用车'
        },
        {
          value:'2',
          label:'客车'
        },
        {
          value:'3',
          label:'货车'
        },
        {
          value:'4',
          label:'半挂牵引车'
        },
        {
          value:'5',
          label:'半挂牵引车及挂车'
        },
        {
          value:'9',
          label:'拖拉机运输机组'
        },
        {
          value:'10',
          label:'轮式专用机械'
        }
      ]
    },
    /*行驶方向*/
    {label:"*行驶方向",value:'',placeholder:"行驶方向",name:"directionOfDriving",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'直行'
        },
        {
          value:'2',
          label:'左转'
        },
        {
          value:'3',
          label:'右转'
        },
        {
          value:'4',
          label:'向左变道'
        },
        {
          value:'5',
          label:'向右变道'
        },
        {
          value:'6',
          label:'倒车'
        },
        {
          value:'7',
          label:'停车'
        },

      ]
    },
    /*事故发生前车辆运动类型*/
    {label:"*事故发生前车辆运动类型",value:'',placeholder:"事故发生前车辆运动类型",name:"vehicleMovementTypeBeforeAccident",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'起步'
        },
        {
          value:'2',
          label:'超车'
        },
        {
          value:'3',
          label:'掉头'
        },
        {
          value:'4',
          label:'倒车'
        },
        {
          value:'5',
          label:'向右变道'
        },
        {
          value:'6',
          label:'向左变道'
        },
        {
          value:'7',
          label:'紧急停车'
        },
        {
          value:'9',
          label:'静止'
        },
        {
          value:'10',
          label:'泊车中'
        },
        {
          value:'11',
          label:'直行加速'
        },
        {
          value:'12',
          label:'直行减速'
        },
        {
          value:'13',
          label:'匀速直行'
        },
        {
          value:'14',
          label:'曲线行驶'
        },
        {
          value:'15',
          label:'左转'
        },
        {
          value:'16',
          label:'右转'
        },
        {
          value:'888',
          label:'其他_________'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*开始反应到碰撞前是否采取转向措施*/
    {label:"*开始反应到碰撞前是否采取转向措施",value:'',placeholder:"开始反应到碰撞前是否采取转向措施",name:"takeSteeringMeasuresBeforeCollision",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.car[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'999-未知'
        },
      ]
    },
    {label:"参与方颜色",value:'',placeholder:"",name:"participantColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"轮胎型号",value:'',placeholder:"",name:"tireModel",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '公路'
        },
        {
          value: '2',
          label: '城市道路'
        },
        {
          value: '3',
          label: '厂矿道路'
        },
        {
          value: '4',
          label: '林区道路'
        },
        {
          value: '5',
          label: '乡村道路'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"胎压(bar)",value:'',placeholder:"",name:"tirePressure",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '高速公路'
        },
        {
          value: '2',
          label: '一级公路'
        },
        {
          value: '3',
          label: '二级公路'
        },
        {
          value: '4',
          label: '三级公路'
        },
        {
          value: '5',
          label: '四级公路'
        },
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"定速巡航装置",value:'',placeholder:"",name:"cruiseControl",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，关闭'
        },
        {
          value:'3',
          label:'有，关着'
        },
        {
          value:'4',
          label:'有，未知是否使用'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"自适应巡航ACC",value:'',placeholder:"",name:"adaptiveCruiseAcc",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，关闭'
        },
        {
          value:'3',
          label:'有，关着'
        },
        {
          value:'4',
          label:'有，未知是否使用'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"安全带提醒装置",value:'',placeholder:"",name:"seatBeltReminder",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'只有驾驶员位置有'
        },
        {
          value:'3',
          label:'驾驶员和副驾驶位置都有'
        },
        {
          value:'4',
          label:'第一排和第二排位置都有'
        },
        {
          value:'5',
          label:'第一排和其他排位置都有'
        }
        ,
        {
          value:'888',
          label:'其他'
        }
      ]
    },
    {label:"是否有主动行人保护装置",value:'',placeholder:"",name:"whetherThereIsActivePedestrianProtectionDevice",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'机械控制可抬升发动机罩'
        },
        {
          value:'3',
          label:'爆燃式可抬升发动机罩'
        },
        {
          value:'4',
          label:'行人保护气囊'
        },
        {
          value:'5',
          label:'行人保护保险杠'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"助力转向类型",value:'',placeholder:"",name:"typeOfPowerSteering",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'电动助力转向器'
        },
        {
          value:'3',
          label:'机械液压助力转向器'
        },
        {
          value:'4',
          label:'电控液压助力转向器'
        },
        {
          value:'888',
          label:'其他'
        }
      ]
    },
    {label:"制动执行结构类型",value:'',placeholder:"",name:"typeOfBrakeActuator",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'前后都为盘式'
        },
        {
          value:'2',
          label:'前盘后鼓'
        },
        {
          value:'3',
          label:'前后都为鼓式'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"是否有EBD制动力分配系统",value:'',placeholder:"",name:"ebdBrakingForceDistributionSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有ABS防抱死系统",value:'',placeholder:"",name:"absAntiLockSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有ESP/VSC车身稳定系统",value:'',placeholder:"",name:"espVscBodyStabilizationSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有ASR/TCS/TRC/ATC牵引力控制",value:'',placeholder:"",name:"asrTcsTrcAtcTractionControlSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有EBA/BAS刹车辅助系统",value:'',placeholder:"",name:"ebaBasBrakeAssistantSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"胎压监测装置",value:'',placeholder:"",name:"tirePressureMonitoringDevice",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car[index].options = this.a.data3.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"并线辅助/盲点监测:",value:'',placeholder:"",name:"concurrentAuxiliaryOrBlindSpotMonitoring",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car[index].options = this.a.data3.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"车道偏离预警LDW",value:'',placeholder:"",name:"laneDepartureWarningLdw",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car[index].options = this.a.data3.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"车道保持系统LKA",value:'',placeholder:"",name:"laneKeepingSystemLka",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car[index].options = this.a.data3.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"自动紧急制动(AEB)",value:'',placeholder:"",name:"automaticEmergencyBraking",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car[index].options = this.a.data3.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"预碰撞安全系统Pre-Collision System",value:'',placeholder:"",name:"preCrashSafetySystemPreCollisionSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car[index].options = this.a.data3.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"驾驶员性别",value:'',placeholder:"",name:"driverGender",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car[index].options = this.a.data3.gender;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '男性'
        },
        {
          value: '2',
          label: '女性'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"驾驶员年龄",value:'',placeholder:"",name:"driverAge",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"驾驶员是否分心",value:'',placeholder:"",name:"isTheDriverDistracted",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'2',
          label:'听音乐'
        },
        {
          value:'3',
          label:'导航中'
        },
        {
          value:'4',
          label:'看风景'
        },
        {
          value:'5',
          label:'捡手机'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"驾驶员生理问题",value:'',placeholder:"",name:"driverPhysiology",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'疾病/眩晕'
        },
        {
          value:'2',
          label:'昏昏欲睡'
        },
        {
          value:'3',
          label:'没有生理问题'
        },
        {
          value:'4',
          label:'其他'
        },
        {
          value:'5',
          label:'未知'
        }
      ]
    },
    {label:"行驶方式",value:'',placeholder:"",name:"vehicleTravelled",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单向单车道或单行道'
        },{
          value: '2',
          label: '单向二车道中的右侧车道'
        },{
          value: '3',
          label: '单向二车道中的左侧车道'
        },{
          value: '4',
          label: '单向三车道或三车道以上中的右侧车道'
        },{
          value: '5',
          label: '单向三车道或三车道以上中的中央车道'
        },{
          value: '6',
          label: '单向三车道或三车道以上中的左侧车道　'
        },{
          value: '7',
          label: '反向车道(逆向行驶)'
        },{
          value: '8',
          label: '紧急停车带'
        },{
          value: '9',
          label: '北侧自行车道'
        },{
          value: '10',
          label: '南侧自行车道'
        },{
          value: '11',
          label: '东侧自行车道'
        },{
          value: '12',
          label: '西侧自行车道'
        },{
          value: '13',
          label: '右转车道，直行'
        },{
          value: '14',
          label: '右转车道，右转'
        },{
          value: '15',
          label: '直行车道，直行'
        },{
          value: '16',
          label: '直行车道，右转'
        },{
          value: '17',
          label: '直行车道，左转'
        },{
          value: '18',
          label: '左转车道，直行'
        },{
          value: '19',
          label: '左转车道，左转'
        },{
          value: '20',
          label: '右转/直行车道，右转'
        },{
          value: '21',
          label: '右转/直行车道，直行'
        },{
          value: '22',
          label: '左转/直行车道，左转'
        },{
          value: '23',
          label: '左转/直行车道，直行'
        },{
          value: '24',
          label: '右边非机动车道，直行'
        },{
          value: '25',
          label: '左边非机动车道，直行'
        },{
          value: '26',
          label: '右边非机动车道，左转'
        },{
          value: '27',
          label: '右边非机动车道，右转'
        },{
          value: '28',
          label: '左边非机动车道，右转'
        },{
          value: '29',
          label: '左边非机动车道，左转'
        },{
          value: '30',
          label: '停车'
        },{
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"主要过错",value:'',placeholder:"",name:"mainAccidentCause",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'000',
          label:'无过失'
        },
        {
          value:'101',
          label:'超速行驶'
        },
        {
          value:'102',
          label:'酒后驾驶'
        },
        {
          value:'103',
          label:'逆向行驶'
        },
        {
          value:'104',
          label:'疲劳驾驶'
        },
        {
          value:'105',
          label:'违法变更车道'
        },
        {
          value:'106',
          label:'违法超车'
        },
        {
          value:'107',
          label:'违法倒车'
        },
        {
          value:'108',
          label:'违法掉头'
        },
        {
          value:'109',
          label:'违法会车'
        },
        {
          value:'110',
          label:'违法牵引'
        },
        {
          value:'111',
          label:'违法抢行'
        },
        {
          value:'112',
          label:'违法上道路行驶'
        },
        {
          value:'113',
          label:'违法停车'
        },
        {
          value:'114',
          label:'违法占道行驶'
        },
        {
          value:'115',
          label:'违法装载'
        },
        {
          value:'116',
          label:'违法占道行驶'
        },
        {
          value:'117',
          label:'违反交通信号'
        },
        {
          value:'118',
          label:'未按规定让行'
        },
        {
          value:'119',
          label:'无证驾驶'
        },
        {
          value:'120',
          label:'不按规定使用灯光'
        },
        {
          value:'121',
          label:'其他影响安全行为'
        },
        {
          value:'122',
          label:'未保持安全车距离'
        },
        {
          value:'201',
          label:'制动不当'
        },
        {
          value:'202',
          label:'转向不当'
        },
        {
          value:'203',
          label:'油门控制不当'
        },
        {
          value:'204',
          label:'其他操作不当'
        },
        {
          value:'501',
          label:'未设置道路安全措施'
        },
        {
          value:'502',
          label:'安全设施损坏灭失'
        },
        {
          value:'503',
          label:'道路缺陷'
        },
        {
          value:'504',
          label:'其他道路原因'
        },
        {
          value:'601',
          label:'自然灾害'
        },
        {
          value:'602',
          label:'机械故障'
        },
        {
          value:'603',
          label:'爆胎'
        },
        {
          value:'604',
          label:'其他意外'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"是否有优先权",value:'',placeholder:"",name:"whetherThereAPriority",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'没有'
        },
        {
          value:'2',
          label:'有'
        }
      ]
    },
    {label:"道路方向",value:'',placeholder:"",name:"roadDirection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'0',
          label:'停着不动'
        },
        {
          value:'1',
          label:'直线'
        },
        {
          value:'2',
          label:'左转直线'
        },
        {
          value:'3',
          label:'右转曲线'
        },
        {
          value:'4',
          label:'S型曲线'
        }
      ]
    },
    {label:"行车记录仪数据",value:'',placeholder:"",name:"vehicleRecordData",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，未读取到'
        },
        {
          value:'3',
          label:'有，读取到'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"EDR数据",value:'',placeholder:"",name:"edrData",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，未读取到'
        },
        {
          value:'3',
          label:'有，读取到'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"事故前车辆要避撞的对象",value:'',placeholder:"",name:"objectAvoidCollisionBeforeAccident",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'道路上的物品'
        },
        {
          value:'2',
          label:'极差（极颠簸）的路面'
        },
        {
          value:'3',
          label:'道路上的动物'
        },
        {
          value:'4',
          label:'道路上的车辆'
        },
        {
          value:'5',
          label:'道路上的非机动车'
        },
        {
          value:'6',
          label:'肇事逃逸'
        },
        {
          value:'7',
          label:'驾驶员不在场'
        },
        {
          value:'8',
          label:'其他避撞措施'
        },
        {
          value:'9',
          label:'未知'
        },

        {
          value:'10',
          label:'没有避撞措施'
        },
        {
          value:'11',
          label:'与来车无直接接触'
        }
      ]
    },
    {label:"事故前车辆的避撞行为",value:'',placeholder:"",name:"collisionAvoidanceBehaviorOfFrontVehicle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'驾驶员不在场'
        },
        {
          value:'2',
          label:'没有避撞措施'
        },
        {
          value:'3',
          label:'刹车'
        },
        {
          value:'4',
          label:'释放刹车踏板'
        },
        {
          value:'5',
          label:'转向'
        },
        {
          value:'6',
          label:'刹车并转向'
        },
        {
          value:'7',
          label:'加速'
        },
        {
          value:'8',
          label:'加速并转向'
        },
        {
          value:'9',
          label:'其他'
        },
        {
          value:'10',
          label:'未知'
        }
      ],
    },
    {label:"开始反应到碰撞前是否采取转向措施",value:'',placeholder:"",name:"whetherSteeringBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'是'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"碰撞前制动时间",value:'',placeholder:"",name:"brakingTimeBeforeCollision",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，沿道路方向'
        },
        {
          value: '3',
          label: '有，横穿道路方向'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"碰撞前制动距离(m)",value:'',placeholder:"",name:"brakingDistanceBeforeCollision",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，非长期性(如汽车)'
        },
        {
          value: '3',
          label: '有，长期性(如建筑物)'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"车外是否有视野盲区",value:'',placeholder:"车外",name:"blindAreaOutsideCar",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'隔离带造成'
        },
        {
          value:'3',
          label:'路边树木造成'
        },
        {
          value:'4',
          label:'路上放置的牌子造成'
        },
        {
          value:'5',
          label:'车外人员造成'
        },
        {
          value:'6',
          label:'车外其他车辆造成'
        },
        {
          value:'7',
          label:'路上固定建筑物造成'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"车内是否有视野盲区",value:'',placeholder:"车内",name:"blindAreaInCar",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'车身部分造成'
        },
        {
          value:'3',
          label:'遮阳板造成'
        },
        {
          value:'4',
          label:'后视镜造成'
        },
        {
          value:'5',
          label:'头部支撑造成'
        },
        {
          value:'6',
          label:'乘员造成'
        },
        {
          value:'7',
          label:'载货造成'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"碰撞角度",value:'',placeholder:"",name:"collisionAngle",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"第一接触点离最前部距离X(mm)",value:'',placeholder:"",name:"firstContactPointFromFrontX",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"第一接触点离最前部距离Y(mm)",value:'',placeholder:"",name:"firstContactPointFromFrontY",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"第一接触点离地面距离Z(mm)",value:'',placeholder:"",name:"firstContactPointFromFrontZ",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"车辆初始速度(km/h)",value:'',placeholder:"",name:"normalDrivingSpeedBeforeVehicleCollision",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"碰撞时速度(km/h)",value:'',placeholder:"",name:"collisionVelocity",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"EES(km/h)",value:'',placeholder:"",name:"ees",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"delta V(km/h)",value:'',placeholder:"",name:"deltaV",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    }
  ],
  car_copy:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'2',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*车辆类型",value:'',placeholder:"",name:"typeOfParticipant",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'乘用车'
        },
        {
          value:'2',
          label:'客车'
        },
        {
          value:'3',
          label:'货车'
        },
        {
          value:'4',
          label:'半挂牵引车'
        },
        {
          value:'5',
          label:'半挂牵引车及挂车'
        },
        {
          value:'9',
          label:'拖拉机运输机组'
        },
        {
          value:'10',
          label:'轮式专用机械'
        }
      ]
    },
    /*行驶方向*/
    {label:"*行驶方向",value:'',placeholder:"行驶方向",name:"directionOfDriving",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'直行'
        },
        {
          value:'2',
          label:'左转'
        },
        {
          value:'3',
          label:'右转'
        },
        {
          value:'4',
          label:'向左变道'
        },
        {
          value:'5',
          label:'向右变道'
        },
        {
          value:'6',
          label:'倒车'
        },
        {
          value:'7',
          label:'停车'
        },

      ]
    },
    /*事故发生前车辆运动类型*/
    {label:"*事故发生前车辆运动类型",value:'',placeholder:"事故发生前车辆运动类型",name:"vehicleMovementTypeBeforeAccident",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'起步'
        },
        {
          value:'2',
          label:'超车'
        },
        {
          value:'3',
          label:'掉头'
        },
        {
          value:'4',
          label:'倒车'
        },
        {
          value:'5',
          label:'向右变道'
        },
        {
          value:'6',
          label:'向左变道'
        },
        {
          value:'7',
          label:'紧急停车'
        },
        {
          value:'9',
          label:'静止'
        },
        {
          value:'10',
          label:'泊车中'
        },
        {
          value:'11',
          label:'直行加速'
        },
        {
          value:'12',
          label:'直行减速'
        },
        {
          value:'13',
          label:'匀速直行'
        },
        {
          value:'14',
          label:'曲线行驶'
        },
        {
          value:'15',
          label:'左转'
        },
        {
          value:'16',
          label:'右转'
        },
        {
          value:'888',
          label:'其他_________'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*开始反应到碰撞前是否采取转向措施*/
    {label:"*开始反应到碰撞前是否采取转向措施",value:'',placeholder:"开始反应到碰撞前是否采取转向措施",name:"takeSteeringMeasuresBeforeCollision",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.car_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'3',
          label:'999-未知'
        },
      ]
    },
    {label:"参与方颜色",value:'',placeholder:"",name:"participantColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"轮胎型号",value:'',placeholder:"",name:"tireModel",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '公路'
        },
        {
          value: '2',
          label: '城市道路'
        },
        {
          value: '3',
          label: '厂矿道路'
        },
        {
          value: '4',
          label: '林区道路'
        },
        {
          value: '5',
          label: '乡村道路'
        },
        {
          value: '888',
          label: '其他'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"胎压(bar)",value:'',placeholder:"",name:"tirePressure",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '高速公路'
        },
        {
          value: '2',
          label: '一级公路'
        },
        {
          value: '3',
          label: '二级公路'
        },
        {
          value: '4',
          label: '三级公路'
        },
        {
          value: '5',
          label: '四级公路'
        },
        {
          value: '000',
          label: '不适用'
        },
        {
          value: '999',
          label: '未知'
        }
      ]
    },
    {label:"定速巡航装置",value:'',placeholder:"",name:"cruiseControl",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，关闭'
        },
        {
          value:'3',
          label:'有，关着'
        },
        {
          value:'4',
          label:'有，未知是否使用'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"自适应巡航ACC",value:'',placeholder:"",name:"adaptiveCruiseAcc",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，关闭'
        },
        {
          value:'3',
          label:'有，关着'
        },
        {
          value:'4',
          label:'有，未知是否使用'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"安全带提醒装置",value:'',placeholder:"",name:"seatBeltReminder",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'只有驾驶员位置有'
        },
        {
          value:'3',
          label:'驾驶员和副驾驶位置都有'
        },
        {
          value:'4',
          label:'第一排和第二排位置都有'
        },
        {
          value:'5',
          label:'第一排和其他排位置都有'
        }
        ,
        {
          value:'888',
          label:'其他'
        }
      ]
    },
    {label:"是否有主动行人保护装置",value:'',placeholder:"",name:"whetherThereIsActivePedestrianProtectionDevice",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'机械控制可抬升发动机罩'
        },
        {
          value:'3',
          label:'爆燃式可抬升发动机罩'
        },
        {
          value:'4',
          label:'行人保护气囊'
        },
        {
          value:'5',
          label:'行人保护保险杠'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"助力转向类型",value:'',placeholder:"",name:"typeOfPowerSteering",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'电动助力转向器'
        },
        {
          value:'3',
          label:'机械液压助力转向器'
        },
        {
          value:'4',
          label:'电控液压助力转向器'
        },
        {
          value:'888',
          label:'其他'
        }
      ]
    },
    {label:"制动执行结构类型",value:'',placeholder:"",name:"typeOfBrakeActuator",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'前后都为盘式'
        },
        {
          value:'2',
          label:'前盘后鼓'
        },
        {
          value:'3',
          label:'前后都为鼓式'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"是否有EBD制动力分配系统",value:'',placeholder:"",name:"ebdBrakingForceDistributionSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car_copy[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有ABS防抱死系统",value:'',placeholder:"",name:"absAntiLockSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car_copy[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有ESP/VSC车身稳定系统",value:'',placeholder:"",name:"espVscBodyStabilizationSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car_copy[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有ASR/TCS/TRC/ATC牵引力控制",value:'',placeholder:"",name:"asrTcsTrcAtcTractionControlSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car_copy[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"是否有EBA/BAS刹车辅助系统",value:'',placeholder:"",name:"ebaBasBrakeAssistantSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car_copy[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"胎压监测装置",value:'',placeholder:"",name:"tirePressureMonitoringDevice",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car_copy[index].options = this.a.data3.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"并线辅助/盲点监测:",value:'',placeholder:"",name:"concurrentAuxiliaryOrBlindSpotMonitoring",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car_copy[index].options = this.a.data3.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"车道偏离预警LDW",value:'',placeholder:"",name:"laneDepartureWarningLdw",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car_copy[index].options = this.a.data3.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"车道保持系统LKA",value:'',placeholder:"",name:"laneKeepingSystemLka",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car_copy[index].options = this.a.data3.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"自动紧急制动(AEB)",value:'',placeholder:"",name:"automaticEmergencyBraking",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car_copy[index].options = this.a.data3.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"预碰撞安全系统Pre-Collision System",value:'',placeholder:"",name:"preCrashSafetySystemPreCollisionSystem",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car_copy[index].options = this.a.data3.nORy;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，关闭'
        },
        {
          value: '3',
          label: '有，开着'
        },
        {
          value: '4',
          label: '有，未知是否使用'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"驾驶员性别",value:'',placeholder:"",name:"driverGender",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.car_copy[index].options = this.a.data3.gender;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '男性'
        },
        {
          value: '2',
          label: '女性'
        },
        {
          value: '999',
          label: '未知'
        },
      ]
    },
    {label:"驾驶员年龄",value:'',placeholder:"",name:"driverAge",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"驾驶员是否分心",value:'',placeholder:"",name:"isTheDriverDistracted",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'2',
          label:'听音乐'
        },
        {
          value:'3',
          label:'导航中'
        },
        {
          value:'4',
          label:'看风景'
        },
        {
          value:'5',
          label:'捡手机'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"驾驶员生理问题",value:'',placeholder:"",name:"driverPhysiology",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'疾病/眩晕'
        },
        {
          value:'2',
          label:'昏昏欲睡'
        },
        {
          value:'3',
          label:'没有生理问题'
        },
        {
          value:'4',
          label:'其他'
        },
        {
          value:'5',
          label:'未知'
        }
      ]
    },
    {label:"行驶方式",value:'',placeholder:"",name:"vehicleTravelled",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '单向单车道或单行道'
        },{
          value: '2',
          label: '单向二车道中的右侧车道'
        },{
          value: '3',
          label: '单向二车道中的左侧车道'
        },{
          value: '4',
          label: '单向三车道或三车道以上中的右侧车道'
        },{
          value: '5',
          label: '单向三车道或三车道以上中的中央车道'
        },{
          value: '6',
          label: '单向三车道或三车道以上中的左侧车道　'
        },{
          value: '7',
          label: '反向车道(逆向行驶)'
        },{
          value: '8',
          label: '紧急停车带'
        },{
          value: '9',
          label: '北侧自行车道'
        },{
          value: '10',
          label: '南侧自行车道'
        },{
          value: '11',
          label: '东侧自行车道'
        },{
          value: '12',
          label: '西侧自行车道'
        },{
          value: '13',
          label: '右转车道，直行'
        },{
          value: '14',
          label: '右转车道，右转'
        },{
          value: '15',
          label: '直行车道，直行'
        },{
          value: '16',
          label: '直行车道，右转'
        },{
          value: '17',
          label: '直行车道，左转'
        },{
          value: '18',
          label: '左转车道，直行'
        },{
          value: '19',
          label: '左转车道，左转'
        },{
          value: '20',
          label: '右转/直行车道，右转'
        },{
          value: '21',
          label: '右转/直行车道，直行'
        },{
          value: '22',
          label: '左转/直行车道，左转'
        },{
          value: '23',
          label: '左转/直行车道，直行'
        },{
          value: '24',
          label: '右边非机动车道，直行'
        },{
          value: '25',
          label: '左边非机动车道，直行'
        },{
          value: '26',
          label: '右边非机动车道，左转'
        },{
          value: '27',
          label: '右边非机动车道，右转'
        },{
          value: '28',
          label: '左边非机动车道，右转'
        },{
          value: '29',
          label: '左边非机动车道，左转'
        },{
          value: '30',
          label: '停车'
        },{
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"主要过错",value:'',placeholder:"",name:"mainAccidentCause",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'000',
          label:'无过失'
        },
        {
          value:'101',
          label:'超速行驶'
        },
        {
          value:'102',
          label:'酒后驾驶'
        },
        {
          value:'103',
          label:'逆向行驶'
        },
        {
          value:'104',
          label:'疲劳驾驶'
        },
        {
          value:'105',
          label:'违法变更车道'
        },
        {
          value:'106',
          label:'违法超车'
        },
        {
          value:'107',
          label:'违法倒车'
        },
        {
          value:'108',
          label:'违法掉头'
        },
        {
          value:'109',
          label:'违法会车'
        },
        {
          value:'110',
          label:'违法牵引'
        },
        {
          value:'111',
          label:'违法抢行'
        },
        {
          value:'112',
          label:'违法上道路行驶'
        },
        {
          value:'113',
          label:'违法停车'
        },
        {
          value:'114',
          label:'违法占道行驶'
        },
        {
          value:'115',
          label:'违法装载'
        },
        {
          value:'116',
          label:'违法占道行驶'
        },
        {
          value:'117',
          label:'违反交通信号'
        },
        {
          value:'118',
          label:'未按规定让行'
        },
        {
          value:'119',
          label:'无证驾驶'
        },
        {
          value:'120',
          label:'不按规定使用灯光'
        },
        {
          value:'121',
          label:'其他影响安全行为'
        },
        {
          value:'122',
          label:'未保持安全车距离'
        },
        {
          value:'201',
          label:'制动不当'
        },
        {
          value:'202',
          label:'转向不当'
        },
        {
          value:'203',
          label:'油门控制不当'
        },
        {
          value:'204',
          label:'其他操作不当'
        },
        {
          value:'501',
          label:'未设置道路安全措施'
        },
        {
          value:'502',
          label:'安全设施损坏灭失'
        },
        {
          value:'503',
          label:'道路缺陷'
        },
        {
          value:'504',
          label:'其他道路原因'
        },
        {
          value:'601',
          label:'自然灾害'
        },
        {
          value:'602',
          label:'机械故障'
        },
        {
          value:'603',
          label:'爆胎'
        },
        {
          value:'604',
          label:'其他意外'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"是否有优先权",value:'',placeholder:"",name:"whetherThereAPriority",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'没有'
        },
        {
          value:'2',
          label:'有'
        }
      ]
    },
    {label:"道路方向",value:'',placeholder:"",name:"roadDirection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'0',
          label:'停着不动'
        },
        {
          value:'1',
          label:'直线'
        },
        {
          value:'2',
          label:'左转直线'
        },
        {
          value:'3',
          label:'右转曲线'
        },
        {
          value:'4',
          label:'S型曲线'
        }
      ]
    },
    {label:"行车记录仪数据",value:'',placeholder:"",name:"vehicleRecordData",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，未读取到'
        },
        {
          value:'3',
          label:'有，读取到'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"EDR数据",value:'',placeholder:"",name:"edrData",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'无'
        },
        {
          value:'2',
          label:'有，未读取到'
        },
        {
          value:'3',
          label:'有，读取到'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"事故前车辆要避撞的对象",value:'',placeholder:"",name:"objectAvoidCollisionBeforeAccident",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'道路上的物品'
        },
        {
          value:'2',
          label:'极差（极颠簸）的路面'
        },
        {
          value:'3',
          label:'道路上的动物'
        },
        {
          value:'4',
          label:'道路上的车辆'
        },
        {
          value:'5',
          label:'道路上的非机动车'
        },
        {
          value:'6',
          label:'肇事逃逸'
        },
        {
          value:'7',
          label:'驾驶员不在场'
        },
        {
          value:'8',
          label:'其他避撞措施'
        },
        {
          value:'9',
          label:'未知'
        },

        {
          value:'10',
          label:'没有避撞措施'
        },
        {
          value:'11',
          label:'与来车无直接接触'
        }
      ]
    },
    {label:"事故前车辆的避撞行为",value:'',placeholder:"",name:"collisionAvoidanceBehaviorOfFrontVehicle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'驾驶员不在场'
        },
        {
          value:'2',
          label:'没有避撞措施'
        },
        {
          value:'3',
          label:'刹车'
        },
        {
          value:'4',
          label:'释放刹车踏板'
        },
        {
          value:'5',
          label:'转向'
        },
        {
          value:'6',
          label:'刹车并转向'
        },
        {
          value:'7',
          label:'加速'
        },
        {
          value:'8',
          label:'加速并转向'
        },
        {
          value:'9',
          label:'其他'
        },
        {
          value:'10',
          label:'未知'
        }
      ],
    },
    {label:"开始反应到碰撞前是否采取转向措施",value:'',placeholder:"",name:"whetherSteeringBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'是'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"碰撞前制动时间",value:'',placeholder:"",name:"brakingTimeBeforeCollision",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，沿道路方向'
        },
        {
          value: '3',
          label: '有，横穿道路方向'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"碰撞前制动距离(m)",value:'',placeholder:"",name:"brakingDistanceBeforeCollision",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '无'
        },
        {
          value: '2',
          label: '有，非长期性(如汽车)'
        },
        {
          value: '3',
          label: '有，长期性(如建筑物)'
        },
        {
          value: '888',
          label: '其他'
        }
      ]
    },
    {label:"车外是否有视野盲区",value:'',placeholder:"车外",name:"blindAreaOutsideCar",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'隔离带造成'
        },
        {
          value:'3',
          label:'路边树木造成'
        },
        {
          value:'4',
          label:'路上放置的牌子造成'
        },
        {
          value:'5',
          label:'车外人员造成'
        },
        {
          value:'6',
          label:'车外其他车辆造成'
        },
        {
          value:'7',
          label:'路上固定建筑物造成'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"车内是否有视野盲区",value:'',placeholder:"车内",name:"blindAreaInCar",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'车身部分造成'
        },
        {
          value:'3',
          label:'遮阳板造成'
        },
        {
          value:'4',
          label:'后视镜造成'
        },
        {
          value:'5',
          label:'头部支撑造成'
        },
        {
          value:'6',
          label:'乘员造成'
        },
        {
          value:'7',
          label:'载货造成'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"碰撞角度",value:'',placeholder:"",name:"collisionAngle",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"第一接触点离最前部距离X(mm)",value:'',placeholder:"",name:"firstContactPointFromFrontX",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"第一接触点离最前部距离Y(mm)",value:'',placeholder:"",name:"firstContactPointFromFrontY",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"第一接触点离地面距离Z(mm)",value:'',placeholder:"",name:"firstContactPointFromFrontZ",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"车辆初始速度(km/h)",value:'',placeholder:"",name:"normalDrivingSpeedBeforeVehicleCollision",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"碰撞时速度(km/h)",value:'',placeholder:"",name:"collisionVelocity",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"EES(km/h)",value:'',placeholder:"",name:"ees",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"delta V(km/h)",value:'',placeholder:"",name:"deltaV",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    }
  ],
  twoWheel:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'1',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*车辆具体种类",value:'',placeholder:"",name:"typeOfParticipant",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'6',
          label:'机动二轮车/三轮车'
        },
        {
          value:'7',
          label:'非机动二轮车/三轮车'
        },
      ]
    },
    {label:"*年龄",value:'',placeholder:"",name:"age",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*性别",value:'',placeholder:"",name:"gender",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value:'1',
          label:'男性'
        },
        {
          value:'2',
          label:'女性'
        },
        {
          value:'3',
          label:'未知'
        }
      ]
    },
    /*与车辆行驶方向的关系*/
    {label:"*与车辆行驶方向的关系",value:'',placeholder:"与车辆行驶方向的关系",name:"relationOfDrivingDirection",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value: '1',
          label: '垂直'
        },
        {
          value: '2',
          label: '同向'
        },
        {
          value: '3',
          label: '相向'
        },
      ]
    },
    /*事故时转向避让反应*/
    {label:"*事故时转向避让反应",value:'',placeholder:"事故时转向避让反应",name:"steeringReactionInAccident",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*事故时二轮车转向灯是否开启*/
    {label:"*事故时二轮车转向灯是否开启",value:'',placeholder:"事故时二轮车转向灯是否开启",name:"whetherTurnSignalOfTwoWheeledVehicleTurned",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*是否有优先权*/
    {label:"*是否有优先权",value:'',placeholder:"是否有优先权",name:"whetherThereAPriority",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*开始反应到碰撞前是否采取转向措施*/
    {label:"*开始反应到碰撞前是否采取转向措施",value:'',placeholder:"开始反应到碰撞前是否采取转向措施",name:"startReactingTakeSteeringMeasures",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*事故发生前车辆运动类型*/
    {label:"*事故发生前车辆运动类型",value:'',placeholder:"事故发生前车辆运动类型",name:"typeVehicleMovementBeforeAccident",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'掉头'
        },
        {
          value:'2',
          label:'向右变道'
        },
        {
          value:'3',
          label:'向左变道'
        },
        {
          value:'4',
          label:'静止'
        },
        {
          value:'5',
          label:'直行加速'
        },
        {
          value:'6',
          label:'直行减速'
        },
        {
          value:'7',
          label:'匀速直行'
        },
        {
          value:'8',
          label:'曲线行驶'
        },
        {
          value:'9',
          label:'左转'
        },
        {
          value:'10',
          label:'右转'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        },

      ]
    },
    /*二轮车乘客数*/
    {label:"*二轮车乘客数",value:'',placeholder:"二轮车乘客数",name:"numberPassengersOnTwoWheelers",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'0'
        },
        {
          value:'2',
          label:'1'
        },
        {
          value:'3',
          label:'2'
        },
        {
          value:'4',
          label:'3'
        },
        {
          value:'5',
          label:'未知'
        },
      ]
    },
    /*二轮车载重*/
    {label:"*二轮车载重(kg)",value:'',placeholder:"二轮车载重",name:"twoWheeledVehicleWeight",type:0,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {

        }
      ]
    },
    {label:"参与方颜色",value:'',placeholder:"",name:"participantColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"长度(mm)",value:'',placeholder:"",name:"vehLength",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"宽度(mm)",value:'',placeholder:"",name:"vehWidth",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"高度(mm)",value:'',placeholder:"",name:"vehHight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"装备质量(kg)",value:'',placeholder:"",name:"weight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"附着系数",value:'',placeholder:"",name:"coeffFrict",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"轴距(cm)",value:'',placeholder:"",name:"wheelbase",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"坐垫离地高度(cm)",value:'',placeholder:"",name:"seatHeightFromTheGround",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"是否为电动车",value:'',placeholder:"",name:"electricVehicleOrNot",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.twoWheel[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"主要过错",value:'',placeholder:"",name:"mainAccidentCause",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'000',
          label:'无过失'
        },
        {
          value:'301',
          label:'超速行驶'
        },
        {
          value:'302',
          label:'酒后驾驶'
        },
        {
          value:'303',
          label:'逆向行驶'
        },
        {
          value:'304',
          label:'违法超车'
        },
        {
          value:'305',
          label:'违法牵引'
        },
        {
          value:'306',
          label:'违法抢行'
        },
        {
          value:'307',
          label:'违法上道路行驶'
        },
        {
          value:'308',
          label:'违法停车'
        },
        {
          value:'309',
          label:'违法占道行驶'
        },
        {
          value:'310',
          label:'违法装载'
        },
        {
          value:'311',
          label:'违反交通信号'
        },
        {
          value:'312',
          label:'未按规定让行'
        },
        {
          value:'313',
          label:'无证驾驶'
        },
        {
          value:'314',
          label:'其他影响安全行为'
        },
        {
          value:'501',
          label:'未设置道路安全措施'
        },
        {
          value:'502',
          label:'安全设施损坏灭失'
        },
        {
          value:'503',
          label:'道路缺陷'
        },
        {
          value:'504',
          label:'其他道路原因'
        },
        {
          value:'601',
          label:'自然灾害'
        },
        {
          value:'602',
          label:'机械故障'
        },
        {
          value:'603',
          label:'爆胎'
        },
        {
          value:'604',
          label:'其他意外'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"二轮车运动方向",value:'',placeholder:"",name:"twoWheelerMovementDirection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '直行'
        },
        {
          value: '2',
          label: '左转'
        },
        {
          value: '3',
          label: '右转'
        },
        {
          value: '4',
          label: '向左变道'
        },
        {
          value: '5',
          label: '向右变道'
        },
        {
          value: '6',
          label: '停车'
        }
      ]
    },
    {label:"二轮车速度(km/h)",value:'',placeholder:"",name:"twoWheelSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"事故时车灯是否开启",value:'',placeholder:"",name:"lightSwitchedOn",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'近光灯'
        },
        {
          value:'3',
          label:'远光灯'
        },
        {
          value:'999',
          label:'未知'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"第一碰撞位置相对自身方位",value:'',placeholder:"",name:"orientationOfFirstCollisionPositionOfTwoWheeledVehicle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'1点钟方向'
        },
        {
          value:'2',
          label:'2点钟方向'
        },
        {
          value:'3',
          label:'3点钟方向'
        },
        {
          value:'4',
          label:'4点钟方向'
        },
        {
          value:'5',
          label:'5点钟方向'
        },
        {
          value:'6',
          label:'6点钟方向'
        },
        {
          value:'7',
          label:'7点钟方向'
        },
        {
          value:'8',
          label:'8点钟方向'
        },
        {
          value:'9',
          label:'9点钟方向'
        },
        {
          value:'10',
          label:'10点钟方向'
        },
        {
          value:'11',
          label:'11点钟方向'
        },
        {
          value:'12',
          label:'12点钟方向'
        },
        {
          value:'13',
          label:'碰撞前已摔倒在地面'
        }
      ]
    },
    {label:"衣着颜色",value:'',placeholder:"",name:"clothingColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"是否戴头盔",value:'',placeholder:"",name:"wearHelmet",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.twoWheel[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"头盔颜色",value:'',placeholder:"",name:"helmetColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橘色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'未知'
        }
      ]
    },
    {label:"在黑暗处或夜间衣物可见性",value:'',placeholder:"",name:"conspicuousnessOfClothingInTheDark",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'明亮的'
        },
        {
          value:'2',
          label:'深色的/不可见'
        },
        {
          value:'3',
          label:'反光的'
        },
        {
          value:'4',
          label:'发光的'
        },
        {
          value:'888',
          label:'其他'
        }
      ]
    }
  ],
  twoWheel_copy:[
    {label:"*事故编号",value:'',placeholder:"事故编号",name:"caseNumber",type:0,warning:0,warningMsg:"1",readonly:true,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {}
      ]
    },
    {label:"*参与方编号",value:'1',placeholder:"参与方编号",name:"participantNumber",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*车辆具体种类",value:'',placeholder:"",name:"typeOfParticipant",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'6',
          label:'机动二轮车/三轮车'
        },
        {
          value:'7',
          label:'非机动二轮车/三轮车'
        },
      ]
    },
    {label:"*年龄",value:'',placeholder:"",name:"age",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {}
      ]
    },
    {label:"*性别",value:'',placeholder:"",name:"gender",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options: [
        {
          value:'1',
          label:'男性'
        },
        {
          value:'2',
          label:'女性'
        },
        {
          value:'3',
          label:'未知'
        }
      ]
    },
    /*与车辆行驶方向的关系*/
    {label:"*与车辆行驶方向的关系",value:'',placeholder:"与车辆行驶方向的关系",name:"relationOfDrivingDirection",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value: '1',
          label: '垂直'
        },
        {
          value: '2',
          label: '同向'
        },
        {
          value: '3',
          label: '相向'
        },
      ]
    },
    /*事故时转向避让反应*/
    {label:"*事故时转向避让反应",value:'',placeholder:"事故时转向避让反应",name:"steeringReactionInAccident",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*事故时二轮车转向灯是否开启*/
    {label:"*事故时二轮车转向灯是否开启",value:'',placeholder:"事故时二轮车转向灯是否开启",name:"whetherTurnSignalOfTwoWheeledVehicleTurned",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*是否有优先权*/
    {label:"*是否有优先权",value:'',placeholder:"是否有优先权",name:"whetherThereAPriority",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*开始反应到碰撞前是否采取转向措施*/
    {label:"*开始反应到碰撞前是否采取转向措施",value:'',placeholder:"开始反应到碰撞前是否采取转向措施",name:"startReactingTakeSteeringMeasures",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    /*事故发生前车辆运动类型*/
    {label:"*事故发生前车辆运动类型",value:'',placeholder:"事故发生前车辆运动类型",name:"typeVehicleMovementBeforeAccident",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'掉头'
        },
        {
          value:'2',
          label:'向右变道'
        },
        {
          value:'3',
          label:'向左变道'
        },
        {
          value:'4',
          label:'静止'
        },
        {
          value:'5',
          label:'直行加速'
        },
        {
          value:'6',
          label:'直行减速'
        },
        {
          value:'7',
          label:'匀速直行'
        },
        {
          value:'8',
          label:'曲线行驶'
        },
        {
          value:'9',
          label:'左转'
        },
        {
          value:'10',
          label:'右转'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        },

      ]
    },
    /*二轮车乘客数*/
    {label:"*二轮车乘客数",value:'',placeholder:"二轮车乘客数",name:"numberPassengersOnTwoWheelers",type:1,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {
          value:'1',
          label:'0'
        },
        {
          value:'2',
          label:'1'
        },
        {
          value:'3',
          label:'2'
        },
        {
          value:'4',
          label:'3'
        },
        {
          value:'5',
          label:'未知'
        },
      ]
    },
    /*二轮车载重*/
    {label:"*二轮车载重(kg)",value:'',placeholder:"二轮车载重",name:"twoWheeledVehicleWeight",type:0,warning:0,warningMsg:"1",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      changes:((index)=>{
        let data = this.a.data3.twoWheel_copy[index];
        if (data.value === '') {
          data.warning = 1;
          data.warningMsg = "必填信息不得为空";
        } else {
          data.warning = 0;
        }
      }),
      options:[
        {

        }
      ]
    },
    {label:"参与方颜色",value:'',placeholder:"",name:"participantColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"长度(mm)",value:'',placeholder:"",name:"vehLength",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"宽度(mm)",value:'',placeholder:"",name:"vehWidth",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"高度(mm)",value:'',placeholder:"",name:"vehHight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"装备质量(kg)",value:'',placeholder:"",name:"weight",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"附着系数",value:'',placeholder:"",name:"coeffFrict",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"轴距(cm)",value:'',placeholder:"",name:"wheelbase",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options:[
        {}
      ]
    },
    {label:"坐垫离地高度(cm)",value:'',placeholder:"",name:"seatHeightFromTheGround",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"是否为电动车",value:'',placeholder:"",name:"electricVehicleOrNot",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.twoWheel_copy[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        },
      ]
    },
    {label:"主要过错",value:'',placeholder:"",name:"mainAccidentCause",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'000',
          label:'无过失'
        },
        {
          value:'301',
          label:'超速行驶'
        },
        {
          value:'302',
          label:'酒后驾驶'
        },
        {
          value:'303',
          label:'逆向行驶'
        },
        {
          value:'304',
          label:'违法超车'
        },
        {
          value:'305',
          label:'违法牵引'
        },
        {
          value:'306',
          label:'违法抢行'
        },
        {
          value:'307',
          label:'违法上道路行驶'
        },
        {
          value:'308',
          label:'违法停车'
        },
        {
          value:'309',
          label:'违法占道行驶'
        },
        {
          value:'310',
          label:'违法装载'
        },
        {
          value:'311',
          label:'违反交通信号'
        },
        {
          value:'312',
          label:'未按规定让行'
        },
        {
          value:'313',
          label:'无证驾驶'
        },
        {
          value:'314',
          label:'其他影响安全行为'
        },
        {
          value:'501',
          label:'未设置道路安全措施'
        },
        {
          value:'502',
          label:'安全设施损坏灭失'
        },
        {
          value:'503',
          label:'道路缺陷'
        },
        {
          value:'504',
          label:'其他道路原因'
        },
        {
          value:'601',
          label:'自然灾害'
        },
        {
          value:'602',
          label:'机械故障'
        },
        {
          value:'603',
          label:'爆胎'
        },
        {
          value:'604',
          label:'其他意外'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"二轮车运动方向",value:'',placeholder:"",name:"twoWheelerMovementDirection",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value: '1',
          label: '直行'
        },
        {
          value: '2',
          label: '左转'
        },
        {
          value: '3',
          label: '右转'
        },
        {
          value: '4',
          label: '向左变道'
        },
        {
          value: '5',
          label: '向右变道'
        },
        {
          value: '6',
          label: '停车'
        }
      ]
    },
    {label:"二轮车速度(km/h)",value:'',placeholder:"",name:"twoWheelSpeed",type:0,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {}
      ]
    },
    {label:"事故时车灯是否开启",value:'',placeholder:"",name:"lightSwitchedOn",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'否'
        },
        {
          value:'2',
          label:'近光灯'
        },
        {
          value:'3',
          label:'远光灯'
        },
        {
          value:'999',
          label:'未知'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"第一碰撞位置相对自身方位",value:'',placeholder:"",name:"orientationOfFirstCollisionPositionOfTwoWheeledVehicle",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'1点钟方向'
        },
        {
          value:'2',
          label:'2点钟方向'
        },
        {
          value:'3',
          label:'3点钟方向'
        },
        {
          value:'4',
          label:'4点钟方向'
        },
        {
          value:'5',
          label:'5点钟方向'
        },
        {
          value:'6',
          label:'6点钟方向'
        },
        {
          value:'7',
          label:'7点钟方向'
        },
        {
          value:'8',
          label:'8点钟方向'
        },
        {
          value:'9',
          label:'9点钟方向'
        },
        {
          value:'10',
          label:'10点钟方向'
        },
        {
          value:'11',
          label:'11点钟方向'
        },
        {
          value:'12',
          label:'12点钟方向'
        },
        {
          value:'13',
          label:'碰撞前已摔倒在地面'
        }
      ]
    },
    {label:"衣着颜色",value:'',placeholder:"",name:"clothingColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橙色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'11',
          label:'银色'
        },
        {
          value:'12',
          label:'香槟色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'不适用'
        }
      ]
    },
    {label:"是否戴头盔",value:'',placeholder:"",name:"wearHelmet",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{
        this.a.data3.twoWheel_copy[index].options = this.a.data3.yORn;
      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'是'
        },
        {
          value:'2',
          label:'否'
        },
        {
          value:'999',
          label:'未知'
        }
      ]
    },
    {label:"头盔颜色",value:'',placeholder:"",name:"helmetColor",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'黄色'
        },
        {
          value:'2',
          label:'橘色'
        },
        {
          value:'3',
          label:'红色'
        },
        {
          value:'4',
          label:'紫色'
        },
        {
          value:'5',
          label:'蓝色'
        },
        {
          value:'6',
          label:'绿色'
        },
        {
          value:'7',
          label:'灰色'
        },
        {
          value:'8',
          label:'棕色'
        },
        {
          value:'9',
          label:'白色'
        },
        {
          value:'10',
          label:'黑色'
        },
        {
          value:'888',
          label:'其他'
        },
        {
          value:'000',
          label:'未知'
        }
      ]
    },
    {label:"在黑暗处或夜间衣物可见性",value:'',placeholder:"",name:"conspicuousnessOfClothingInTheDark",type:1,warning:0,warningMsg:"",readonly:false,
      focus:((index)=>{

      }),
      blur:((index)=>{

      }),
      changes:((index)=>{

      }),
      options: [
        {
          value:'1',
          label:'明亮的'
        },
        {
          value:'2',
          label:'深色的/不可见'
        },
        {
          value:'3',
          label:'反光的'
        },
        {
          value:'4',
          label:'发光的'
        },
        {
          value:'888',
          label:'其他'
        }
      ]
    }
  ]
};

export default {data1,data2,data3};



// WEBPACK FOOTER //
// ./src/assets/javascript/dataProcess.js